/* eslint-disable no-undef */
'use strict';
var baseSearch = require('base/search/search');
var initVisualCarousel = require('../components/visualLinks');

let mobileMediaQuery = window.matchMedia('(max-width: 1023px)');

var firstLevelFilterEle = $('.firstLevelFilter .nav-item .nav-link');
var secondLevelFilterEle = $('.secondLevelFilter .experience-dynamic-filterTile');

const isCustomFilterEnabled = $('.refinements #price').data('custom-filter-enabled');
var siteLanguage = window.digitalData.page.pageInfo.language ? window.digitalData.page.pageInfo.language.split('-')[0] : null;
var l2Category = window.digitalData.page.category.subCategory1;
var storedfilteroptionsflag = $('#retain-filter-attributes').attr('data-retainrefinementsforcategory');
var suggestedFilterobjType = l2Category;
var isRegisteredUser;
var selectedFromPanelCategory = window.digitalData.page.category.subCategory2 ? window.digitalData.page.category.subCategory2 : window.digitalData.page.category.subCategory1;
var retainFilterActivatedFlag = false;
var isfilteredPage;
var existingSelectedFromPanel;
var selectedSizes = false;
var selectedColors = false;
var recommendedFilters = false;
var carouselInit = require('../components/recommendationCarousel');
var productTile = require('../components/productTile');
var carousel = require('../components/carousel');

require('../../icons/bvstarsvg/star_0.1.svg');
require('../../icons/bvstarsvg/star_0.2.svg');
require('../../icons/bvstarsvg/star_0.3.svg');
require('../../icons/bvstarsvg/star_0.4.svg');
require('../../icons/bvstarsvg/star_0.5.svg');
require('../../icons/bvstarsvg/star_0.6.svg');
require('../../icons/bvstarsvg/star_0.7.svg');
require('../../icons/bvstarsvg/star_0.8.svg');
require('../../icons/bvstarsvg/star_0.9.svg');
require('../../icons/bvstarsvg/star_full.svg');
require('../../icons/bvstarsvg/staroutline.svg');
require('../../icons/infoNotification.svg');

/**
 * Wishlist Status functionality
 */
function handleWishlistStatus() {
    if ($('.wishlistitems').text().length > 0) {
        if (localStorage.getItem('wishlistItems') === null) {
            localStorage.setItem('wishlistItems', '');
            localStorage.setItem('wishlistItems', JSON.stringify($('.wishlistitems').text().split(',')));
        }
    }

    var wishlistItems = JSON.parse(localStorage.getItem('wishlistItems'));
    for (var i = 0; i < wishlistItems.length; i++) {
        var $tileElement = $('#' + wishlistItems[i]);
        $tileElement.find('.wishlistTile').addClass('remove-from-wishlist');
        $tileElement.find('.wishlistTile').attr('title', $tileElement.find('.wishlistTile').data('remove-wishlist'));
        $tileElement.find('.icon-wishlist').removeClass('icon-wishlist-o');
        $tileElement.find('.icon-wishlist').addClass('icon-wishlist-s');
    }
}

/**
 * Show/hide einstein carousel based on filter and sort values
 */
function handleEinstein() {
    if ($('select[name=sort-order] .default-sort-option').length) {
        if ($('select[name=sort-order]').find(':selected').hasClass('default-sort-option')) {
            $('.recommendations-cdp').show();
            if ($('.recommendations-cdp .product-carousel.slick-initialized').length) {
                for (let i = 0; i < $('.recommendations-cdp .product-carousel.slick-initialized').length; i++) { // For both AI and einstein recommenders
                    $('.recommendations-cdp .product-carousel').get(i).slick.setPosition();
                }
            }
        } else {
            $('.recommendations-cdp').hide();
        }
    } else if ($('select[name=sort-order]').length && $('select[name=sort-order]').find(':selected')[0].index === 0) {
        $('.recommendations-cdp').show();
        if ($('.recommendations-cdp .product-carousel.slick-initialized').length) {
            for (let i = 0; i < $('.recommendations-cdp .product-carousel.slick-initialized').length; i++) { // For both AI and einstein recommenders
                $('.recommendations-cdp .product-carousel').get(i).slick.setPosition();
            }
        }
    } else {
        $('.recommendations-cdp').hide();
    }
}

/**
 * Display all available sizes if hidden items behind Show all link are selected
 **/
function handleSizeFilter() {
    if ($('.refinement-size .values .see-all-item .selected').length) {
        $('.refinement-size .values .see-all-link').trigger('click');
    }
}

$(document).ready(function () {
    $('.refinements').removeClass('d-none');
    $('.refinements').animate('slow', 100);
    if ($('.sort-custom-select').find('[selected]').length) {
        $('.sort-custom-select').find('[selected]').prop('selected', true);
    } else {
        $($('.sort-custom-select option')[0]).prop('selected', true);
    }
    handleEinstein();
    if ($('.pd-plp-hreflang-tags').children().length && $('[hreflang]').length) {
        var responseHrefLangLinks = $('.pd-plp-hreflang-tags').children();
        var domHrefLangLinks = $('[hreflang]');
        for (var i = 0; i < responseHrefLangLinks.length; i++) {
            for (var j = 0; j < domHrefLangLinks.length; j++) {
                if (responseHrefLangLinks[i].hreflang === domHrefLangLinks[j].hreflang && responseHrefLangLinks[i].href !== domHrefLangLinks[j].href) {
                    domHrefLangLinks[j].href = responseHrefLangLinks[i].href;
                    break;
                }
            }
        }
    } else if ($('.pd-refinement-based-seo').text() === 'true' && $('.pd-refinement-based-seo').text() !== null && $('.pd-plp-hreflang-tags').children().length === 0 && $('[hreflang]').length > 0) {
        $('[hreflang]').remove();
    }
});

// Updating data attributes for analytics on CDP recommender tiles.
$(window).on('load', function () {
    if ($('.recommendations-cdp .carousel-container .product a[data-lulu-track]').length) {
        let trackAttr = $('.recommendations-cdp .carousel-container .product a').attr('data-lulu-track');
        if (typeof trackAttr !== 'undefined' && trackAttr !== false) {
            $('.recommendations-cdp .carousel-container .product a').attr('data-lulu-track', 'cdp-recommendations-bestSellers');
        }
    }
    setTimeout(function () {
        $('body #onetrust-group-container #onetrust-policy-text .ot-cookie-policy-link').attr('aria-label', 'Privacy Policy, opens in a new tab');
    }, 3000);
});

// Tracking clicks on CDP recommender product tiles.
$(document).on('click', '.recommendations-cdp .carousel-container .product a[data-lulu-track="cdp-recommendations-bestSellers"]', function (event) {
    event.stopImmediatePropagation();
    var prodJSON = JSON.parse($(this).attr('data-lulu-attributes').replace(/'/g, '"'));
    prodJSON.attributes.position = parseInt($($(this).closest('.product-carousel-slide')).attr('data-slick-index'), 10) + 1;
    _satellite.track('cdp-recommendations-bestSellers', {
        product: prodJSON
    });
});

/**
 * See all functionality for refinements (Size/Colors)
 * On clicking see all link, hidden items will be shown & see all link will be removed
 */
function openSeeAll() {
    $(document).on('click keydown', '.see-all-link', function (e) {
        e.preventDefault();

        // Get the link & its parent
        var seeAllLink = $(this);
        var seeAllLinkContainer = $(this).parent();
        var showLessLinkContainer = $(this).parentsUntil('.card-body').find('.show-less');

        // Get refinements container
        var listContainer = seeAllLink.closest('.content');

        // Find hidden refinements in the container & display them
        var hiddenListItems = listContainer.find('.see-all-item');
        hiddenListItems.toggleClass('d-lg-none');

        // Delete see all link from DOM
        seeAllLinkContainer.removeClass('d-lg-block');
        showLessLinkContainer.addClass('d-lg-block');
        if (e.key === ' ' || e.key === 'Enter') {
            setTimeout(function () {
                listContainer.find('.see-all-item').eq('0').find('a')[0].focus();
            }, 0);
        }
    });

    $(document).on('click', '.show-less-link', function (e) {
        e.preventDefault();

        // Get the link & its parent
        var showLessLink = $(this);
        var showLessLinkContainer = $(this).parent();
        var seeAllLinkContainer = $(this).parentsUntil('.card-body').find('.see-all');

        // Get refinements container
        var listContainer = showLessLink.closest('.content');

        // Find hidden refinements in the container & display them
        var hiddenListItems = listContainer.find('.see-all-item');
        hiddenListItems.toggleClass('d-lg-none');

        // Delete see all link from DOM
        showLessLinkContainer.removeClass('d-lg-block');
        seeAllLinkContainer.addClass('d-lg-block');

        setTimeout(function () {
            listContainer.find('.see-all-link')[0].focus();
        }, 0);
    });
}

// quick filter classes
var firstLevelFilterClass = '.firstLevelFilter';
var secondLevelFilterClass = '.secondLevelFilter';
var firstLevelFilterSelector = $('.firstLevelFilter');

/**
 * Get Search Parameters from URL
 * @param {string} filterLevelClass - type of the filter
 * @return {undefined}
 */
function handleQuickFilter(filterLevelClass) {
    $('body').css('pointer-events', 'none');
    var classFilter = (filterLevelClass === '.firstLevelFilter') ? 'li a' : '.experience-dynamic-filterTile a.tile-copy-link';
    var $filter = $(filterLevelClass + ' ' + classFilter);
    var filterType;
    var firstItemSelected = true;
    var tileImageLink;
    for (var i = 1; i < $filter.length; i++) {
        var filterTypeSelector = $filter[i];
        filterType = $(filterLevelClass).find($(filterTypeSelector)).data('filter-type');
        if (filterType) {
            filterType = filterType.toLowerCase();
            var refinementFilter = $('.' + filterType + ' li a');
            var quickFilter = $($filter[i]);
            var quickFilterValue = quickFilter.data('filter-value');
            if (quickFilterValue && quickFilterValue !== 'All Filter Link') {
                // flag for show or hide the quick filter based on the left side refinement
                var hideFilter = true;
                for (var j = 0; j < refinementFilter.length; j++) {
                    var actualFilter = $(refinementFilter[j]);
                    var refinementFilterValue = $(refinementFilter[j]).data('filter-value');
                    if (quickFilterValue === refinementFilterValue) {
                        quickFilter.attr('href', actualFilter.attr('data-single-pushstate-url'));
                        quickFilter.attr('data-refinementurl', actualFilter.attr('data-singleurl'));
                        quickFilter.attr('data-hrefurl', actualFilter.attr('data-single-pushstate-url'));
                        if (quickFilter.parent().hasClass('tile-component-inner')) {
                            tileImageLink = quickFilter.parent().find('.image-wrapper.tile-link');
                            tileImageLink.attr('href', actualFilter.attr('data-single-pushstate-url'));
                            tileImageLink.attr('data-refinementurl', actualFilter.attr('data-singleurl'));
                            tileImageLink.attr('data-hrefurl', actualFilter.attr('data-single-pushstate-url'));
                        }
                        hideFilter = false;
                    }
                }
                quickFilter = (filterLevelClass === '.firstLevelFilter') ? quickFilter : quickFilter.parents('.experience-dynamic-filterTile');
                if (hideFilter) {
                    quickFilter.addClass('d-none');
                } else {
                    quickFilter.removeClass('d-none');
                }
            }
        }

        var refinementSelectedCount = $('.' + filterType + ' input[type="checkbox"]:checked').length;
        if (firstLevelFilterSelector.length > 0 && filterLevelClass === '.firstLevelFilter') {
            firstLevelFilterSelector.css('opacity', '1');
            if (filterType === $($('.firstLevelFilter .nav-item')[i]).find('.nav-link').data('filter-type').toLowerCase()) {
                if (refinementSelectedCount === 1) {
                    firstItemSelected = false;
                    firstLevelFilterSelector.find('li:first-child').find('.nav-link').removeClass('selected').attr('aria-selected', 'false');
                }
                if (firstItemSelected) {
                    firstLevelFilterSelector.find('li:first-child').find('.nav-link').addClass('selected').attr('aria-selected', 'true');
                    firstLevelFilterSelector.find('li:not(:first-child)').find('.nav-link').removeClass('selected').attr('aria-selected', 'false');
                } else if (refinementSelectedCount > 0) {
                    var slectedRefineDataFilterVal = $('.' + filterType + ' input[type="checkbox"]:checked').parents('a').data('filter-value');
                    firstLevelFilterSelector.find('li').find('.nav-link[data-filter-value="' + slectedRefineDataFilterVal + '"]').addClass('selected').attr('aria-selected', 'true');
                }
            }
            $(firstLevelFilterClass).css('pointer-events', 'all');
        }

        if ($('.secondLevelFilter').length > 0 && filterLevelClass === '.secondLevelFilter' && i < $filter.length) {
            var secondLevelFilterType = $($('.secondLevelFilter .experience-dynamic-filterTile')[i]).find('a').data('filter-type').toLowerCase();
            if (filterType === secondLevelFilterType) {
                if (refinementSelectedCount === 1) {
                    firstItemSelected = false;
                    $('.secondLevelFilter .experience-dynamic-filterTile:first-child')
                        .removeClass('selected')
                        .find('a')
                        .attr('aria-selected', 'false');
                }
                if (firstItemSelected) {
                    $('.secondLevelFilter .experience-dynamic-filterTile:first-child')
                        .addClass('selected')
                        .find('a')
                        .attr('aria-selected', 'true');
                    $('.secondLevelFilter .experience-dynamic-filterTile:not(:first-child)')
                        .removeClass('selected')
                        .find('a')
                        .attr('aria-selected', 'false');
                } else if (refinementSelectedCount > 0) {
                    var selectedRefineDataSecondLevelFilterVal = $('.' + filterType + ' input[type="checkbox"]:checked')
                        .parents('a')
                        .data('filter-value');
                    $('.secondLevelFilter .experience-dynamic-filterTile')
                        .removeClass('selected')
                        .find('a')
                        .attr('aria-selected', 'false');
                    $('.secondLevelFilter')
                        .find('a[data-filter-value="' + selectedRefineDataSecondLevelFilterVal + '"]')
                        .parents('.experience-dynamic-filterTile')
                        .addClass('selected')
                        .find('a')
                        .attr('aria-selected', 'true');
                }
            }
        }
    }

    if ($('.secondLevelFilter').length > 0) {
        var pdSwiperFilter = require('../components/pdSwiperFilter');
        pdSwiperFilter.init();
        $(secondLevelFilterClass).css('pointer-events', 'all');
        $('.secondLevelFilter').css('opacity', 1);
    }

    if ($('.collection-filter-swiper-init').length) {
        var activeSlides = $('.collection-filter-swiper-init .experience-dynamic-filterTile:not(.d-none)');
        activeSlides.each(function (k, e) {
            var tileLink = $(e).find('.tile-link');
            var dataLulu = JSON.parse(tileLink.attr('data-lulu-attributes').replace(/'/g, '"'));
            dataLulu.attributes.position = k + 1;
            tileLink.attr('data-lulu-attributes', JSON.stringify(dataLulu));
        });
    }
    $('body').css('pointer-events', 'all');
}

/**
 * Function to add Read more link to Top SEO content if the content exceeds 2 lines
 * @param {JQuery} $ele - DOM element for SEO text
*/
function styleSEOContent($ele) {
    for (var i = 0; i < $ele.length; i++) {
        var lines = $ele[i].getClientRects().length;
        var $seoParent = $ele.parents('.seo-parent');
        if (lines > 2 || (lines <= 2 && $ele.next('h2').length)) {
            if ($ele[0] === $('div.seo-bottom-rich-content')[0]) {
                let headerHeight = $seoParent.find($('.category-title')).outerHeight(true);
                let contentHeight = $seoParent.height();
                $seoParent.css('min-height', headerHeight + contentHeight);
            }
            $seoParent.addClass('expandable');
            $seoParent.siblings('.seo-gradient').removeClass('d-none');
            $seoParent.siblings('.expandable-btn-div').find('.showMore').removeClass('d-none');
        }

        if (lines <= 2 && $ele[0] === $('div.seo-bottom-rich-content')[0]) {
            let headerHeight = $seoParent.find($('.category-title')).outerHeight(true);
            let contentHeight = $seoParent.height();
            $seoParent.css('max-height', headerHeight + contentHeight);
        }
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector)
        .empty()
        .html($updates.html());
}
/**
 * Updates the meta data on the page when refinement is selected.
 * @param {string} response - Ajax response HTML code
 */
function updateMetaDataTags(response) {
    var $result = $(response);
    if ($result.find('.plp-page-title').text()) {
        document.title = $result.find('.plp-page-title').text();
    }
    if ($result.find('.plp-category-title').html()) {
        $('.category-title').html($result.find('.plp-category-title').html());
    }
    if ($result.find('.top-seo-content').html()) {
        $('.seo-rich-content').empty().html($result.find('.top-seo-content').html());
    }
    if ($result.find('.bottom-seo-content').html()) {
        $('.seo-bottom-rich-content').empty().html($result.find('.bottom-seo-content').html());
    }
    if ($result.find('.plp-page-description').html()) {
        document.querySelector('meta[name="description"]').setAttribute('content', $result.find('.plp-page-description').html());
    }
    if ($result.find('.plp-hreflang-tags').children().length && $('[hreflang]').length) {
        var responseHrefLangLinks = $result.find('.plp-hreflang-tags').children();
        var domHrefLangLinks = $('[hreflang]');
        for (var i = 0; i < responseHrefLangLinks.length; i++) {
            for (var j = 0; j < domHrefLangLinks.length; j++) {
                if (responseHrefLangLinks[i].hreflang === domHrefLangLinks[j].hreflang && responseHrefLangLinks[i].href !== domHrefLangLinks[j].href) {
                    domHrefLangLinks[j].href = responseHrefLangLinks[i].href;
                    break;
                }
            }
        }
    } else if ($('[hreflang]').length && $result.find('.plp-hreflang-tags').children().length === 0) {
        $('[hreflang]').remove();
    } else if ($('[hreflang]').length === 0 && $result.find('.plp-hreflang-tags').children().length > 0) {
        $('head').append($result.find('.plp-hreflang-tags').children());
    }
    if ($result.find('.plp-canonical-url').html()) {
        var links = document.getElementsByTagName('link');
        for (var k = 0; k < links.length; k++) {
            if (links[k].getAttribute('rel') === 'canonical') {
                links[k].href = $result.find('.plp-canonical-url').text();
                break;
            }
        }
    }
    if ($result.find('.plp-robots').html()) {
        document.querySelector('meta[name="robots"]').setAttribute('content', $result.find('.plp-robots').html());
    }
}
/**
 * ISBS-439 : Adds 'next' and/or 'prev' links to header
 *
 * @param {boolean} replace - replace previous next/pre link elements if true, exit function if next/pre found if false
 */
function addPaginationLinks(replace) {
    // Do this on CDPs only
    if ($('.search-results') < 1) {
        return;
    }
    if (!replace) {
        // If rel=next or rel=prev found exit
        if ($('head link[rel=next],[rel=prev]').length > 0) {
            return;
        }
    }
    var pageLinksMarkup = '';
    const currentRenderItems = $('.product-tile').length;
    const minRenderedItems = 12;
    const perItemsAfterButtonClick = 48;
    const totalResultsRegex = /\d+\s/g;
    const totalResultsHtml = $('.result-count').html();
    var totalResultsText = '';
    var totalResults = 0;

    if (totalResultsHtml) {
        totalResultsText = totalResultsHtml.match(totalResultsRegex);
        totalResults = parseInt(totalResultsText, 10);
    }

    var pagedSearchParams = new URLSearchParams(window.location.search);

    // Only do this if search results are more than 'minimum items rendered on page before auto pull'
    if (totalResultsHtml && (totalResults > minRenderedItems)) {
        // If current rendered items is less than 'button appears' threshold
        if (currentRenderItems > minRenderedItems) {
            if (currentRenderItems < perItemsAfterButtonClick) {
                pagedSearchParams.set('sz', currentRenderItems - minRenderedItems);
            } else {
                pagedSearchParams.set('sz', currentRenderItems - perItemsAfterButtonClick);
            }
            pageLinksMarkup += '<link rel="prev" href="https://' + window.location.hostname + window.location.pathname + '?' + pagedSearchParams.toString() + '" />';
        }
        if (currentRenderItems < totalResults) {
            if (currentRenderItems < perItemsAfterButtonClick) {
                pagedSearchParams.set('sz', currentRenderItems + minRenderedItems);
            } else {
                pagedSearchParams.set('sz', currentRenderItems + perItemsAfterButtonClick);
            }
            pageLinksMarkup += '<link rel="next" href="https://' + window.location.hostname + window.location.pathname + '?' + pagedSearchParams.toString() + '" />';
        }
        if (replace) {
            // Find previous rel links and remove them from the DOM.
            if ($('head link[rel=next],[rel=prev]').length > 0) {
                $('head link[rel=next],[rel=prev]').remove();
            }
        }

        $('head').append(pageLinksMarkup);
    }
}
/**
 * Expand/Collapse categories on click
 */
function handleCategories() {
    var selectedLink = $('.refinement-categories .values.content').find('.selected');
    var selectedCategoryLevel = selectedLink.parent().data('category-level');
    var selectedCategory = selectedLink.closest('.level' + selectedCategoryLevel);
    var selectedCategoryParent = selectedCategory.closest('.level' + (selectedCategoryLevel - 1));
    var selectedCategoryGrandparent = selectedCategoryParent.closest('.level' + (selectedCategoryLevel - 2));

    selectedCategory.removeClass('d-none');
    // don't show children category after level 3
    if (selectedCategoryLevel < 4) {
        selectedCategory.find('.level' + (selectedCategoryLevel + 1)).removeClass('d-none');
    }

    // if we select category level that is not 1
    if (selectedCategoryLevel !== 1) {
        if (selectedCategoryLevel < 4) {
            $('.level' + selectedCategoryLevel).not(selectedCategory).addClass('d-none');
        } else {
            $('.level' + selectedCategoryLevel).not(selectedCategory).removeClass('d-none');
        }
        selectedCategoryParent.removeClass('d-none');
        selectedCategoryGrandparent.removeClass('d-none');
    } else {
        // if category level is root, don't remove categories
        $('.level' + selectedCategoryLevel).removeClass('d-none');
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        $results
            .find('.' + $(this)[0].className.replace(/ /g, '.'))
            .addClass('active');
    });

    updateDom($results, '.refinements');
}
/**
 * Handle show and hide of hero banner on refinement selection.
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @param {boolean} pageRefresh - true when page is refreshed.
 * @return {undefined}
 */
function handleHeroBannerUpdate($results, selector, pageRefresh) {
    var $updates = $results.find(selector);
    if ($('.category-hero-slot').length > 0 && $updates.length > 0 && $updates.html().search('image-hero-banner') > 0) {
        $('.category-hero-slot').addClass('hide');
        if (!pageRefresh) {
            $(selector).empty().html($updates.html()).removeClass('hide');
        }
    } else if ($updates.length > 0 && $updates.html().search('image-hero-banner') === -1 && $('.category-hero-slot').length > 0) {
        $(selector).addClass('hide');
        $('.category-hero-slot').removeClass('hide');
    } else if ($('.category-hero-slot').length === 0) {
        $(selector).empty().html($updates.html());
    }
}


/**
 * Handle show/hide of visual quick links on refinement selection
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @param {boolean} pageRefresh - true when we refresh the page.
 * @return {undefined}
 */
function handleVisualQuickLinksUpdate($results, selector, pageRefresh) {
    var $updates = $results.find(selector);
    if ($('.category-visual-link-slot').length > 0 && $updates.length > 0 && $updates.html().search('visual-links-component') > 0) {
        $('.category-visual-link-slot').addClass('hide');
        if (!pageRefresh) {
            $(selector).empty().html($updates.html()).removeClass('hide');
        }
    } else if ($updates.length > 0 && $updates.html().search('visual-links-component') === -1 && $('.category-visual-link-slot').length > 0) {
        $(selector).addClass('hide');
        $('.category-visual-link-slot').removeClass('hide');
    } else if ($('.category-visual-link-slot').length === 0) {
        $(selector).empty().html($updates.html());
    }
}

/**
 * Update the lead color for the products based on color selection
 * @param {Object} results - Jquey dom object for response
 */
function handleColorFilterLeadColor(results) {
    var products = results.find('.product');
    var productIDs = [];
    var searchParams = new URLSearchParams(window.location.search);
    var pmid = searchParams.get('pmid') || '';
    var selectedcolorleadvarianturl = $('.product-grid').data('getleadvarianturl');
    for (var i = 0; i < products.length; i++) {
        var product = products[i];
        var productID = product.dataset.pid;
        if (productID !== 'null' && productID !== false) {
            productIDs.push(productID);
        }
    }
    productIDs = productIDs.join();
    if (productIDs.length > 0) {
        $.ajax({
            url: selectedcolorleadvarianturl,
            data: {
                pid: productIDs,
                selectedColorFilterValue: selectedColors,
                pmid: pmid
            },
            type: 'post',
            success: function (response) {
                if (response.selectorColorleadVariants !== undefined) {
                    var selectorColorleadVariantsArray = response.selectorColorleadVariants;
                    for (var j = 0; j < selectorColorleadVariantsArray.length; j++) {
                        var prodID = '#' + selectorColorleadVariantsArray[j].productID;
                        var colorSwatchesWrapper = $(prodID).find('.swatches');
                        var leadColor = selectorColorleadVariantsArray[j].colorSelectedLeadColor;
                        $(prodID).find("[data-color-code='" + leadColor + "']").insertBefore($(prodID).find('.color-swatches a:not(.plusSymbol,.unselectable):first'));
                        if (colorSwatchesWrapper.hasClass('slick-initialized')) {
                            carousel.removeCarousel(colorSwatchesWrapper);
                        }
                        var $imgSwatchesElm = colorSwatchesWrapper.find('img.cdp-swatches');
                        if ($imgSwatchesElm.length > 1) {
                            $imgSwatchesElm.eq(0).trigger('click');
                            $imgSwatchesElm.eq(0).parents('.swatchAnchor').removeClass('selected');
                        }
                    }
                    // Adding timeout to load before initializing carousel
                    setTimeout(function () {
                        productTile.initSwatch($('.swatches'));
                        $('.color-refined .image-container').css('opacity', '1');
                        $('.color-refined .swatches').css('opacity', '1');
                    }, 900);
                }
            }
        });
    }
}
/**
 * Updates the Out of stock color variants on the page
 *
 * @param {Object} results - jQuery DOM element
 * @return {undefined}
 */
function updateOOSColorVariants(results) {
    var products = results.find('.product');
    var productIDs = [];
    var getOOSColorsUrl = $('.product-grid').data('oosurl');
    for (var i = 0; i < products.length; i++) {
        var product = products[i];
        var productID = product.dataset.pid;
        if (productID !== 'null' && productID !== false) {
            productIDs.push(productID);
        }
    }
    productIDs = productIDs.join();
    if (productIDs.length > 0) {
        $.ajax({
            url: getOOSColorsUrl,
            data: {
                pid: productIDs,
                selectedSizes: selectedSizes
            },
            type: 'post',
            success: function (response) {
                if (response.variantAvailabilityArray !== undefined) {
                    var variantAvailabilityArray = response.variantAvailabilityArray;
                    for (var j = 0; j < variantAvailabilityArray.length; j++) {
                        var prodID = '#' + variantAvailabilityArray[j].productID;
                        var availabilityMapArr = Object.entries(variantAvailabilityArray[j].availabilityMap);
                        $(prodID).find('.color-swatches a:not(.plusSymbol)').addClass('unselectable');
                        var colorSwatchesWrapper = $(prodID).find('.swatches');
                        colorSwatchesWrapper.css('opacity', '0');
                        if (colorSwatchesWrapper.hasClass('slick-initialized')) {
                            carousel.removeCarousel(colorSwatchesWrapper);
                        }
                        for (const [key, value] of availabilityMapArr) {
                            if (value && !value.available) {
                                $(prodID).find("[data-color-code='" + key + "']")
                                .addClass('unselectable').attr('aria-disabled', 'true');
                            } else if (value && value.available) {
                                $(prodID).find("[data-color-code='" + key + "']")
                                .removeClass('unselectable').removeAttr('aria-disabled', 'true');
                            }
                            if (value && value.available && value.isLowInStock) {
                                $(prodID).find("[data-color-code='" + key + "']").find('img').attr('data-islis', true);
                            }
                        }
                        if (colorSwatchesWrapper.hasClass('slick-initialized')) {
                            colorSwatchesWrapper.find('.slick-list').append($(prodID).find('.swatchAnchor.unselectable'));
                        } else {
                            colorSwatchesWrapper.append($(prodID).find('.swatchAnchor.unselectable'));
                        }
                        var $imgSwatchesElm = colorSwatchesWrapper.find('img.cdp-swatches');
                        if ($imgSwatchesElm.length > 1) {
                            $imgSwatchesElm.eq(0).trigger('click');
                            $imgSwatchesElm.eq(0).parents('.swatchAnchor').removeClass('selected');
                        }
                        var $firstSwatchImg = $(prodID).find('.color-swatches a.swatchAnchor').first().find('img');
                        var isLowInStock = $firstSwatchImg.data('islis');
                        if (isLowInStock) {
                            var lowInStockBadge = $firstSwatchImg.data('lis-msg');
                            var $imgContainer = $(prodID).find('.image-container');
                            $imgContainer.find('.promoCallout').addClass('d-none');
                            if (!$imgContainer.find('.lis-badge').length) {
                                $imgContainer.append('<div class="lis-badge">' + lowInStockBadge + '</div>');
                            }
                        }
                    }
                    // Adding timeout to load before initializing carousel
                    setTimeout(function () {
                        productTile.initSwatch($('.swatches'));
                        $('.swatches').css('opacity', '1');
                    }, 700);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}
/**
 * Update Stored Suggested Filter Link Status
 */
function updateStoredFilterStatus() {
    if (sessionStorage.getItem('selectedFromPanelGroup_' + siteLanguage)) {
        existingSelectedFromPanel = JSON.parse(sessionStorage.getItem('selectedFromPanelGroup_' + siteLanguage));
    }
    if ($('.purchased-suggested-filters .filters').is(':empty') && (JSON.parse(localStorage.getItem('browsedFilter_' + siteLanguage)) !== null && JSON.parse(localStorage.getItem('browsedFilter_' + siteLanguage))[suggestedFilterobjType] !== undefined)) {
        var existingSuggestedFilters = JSON.parse(localStorage.getItem('browsedFilter_' + siteLanguage))[suggestedFilterobjType];
        var storedFilteredObjTypes = existingSuggestedFilters.filters;
        $('.suggested-filters .filters').empty();
        Object.keys(storedFilteredObjTypes).forEach(filterType => {
            if (storedFilteredObjTypes[filterType].length !== 0) {
                storedFilteredObjTypes[filterType].forEach((val) => {
                    var filterLink;
                    if (filterType === 'size') {
                        filterLink = $('.refinements:not(.d-none) [data-filter-id="' + filterType + '"] [data-localizedsize="' + val + '"]').parents('a');
                    } else if (filterType.toLowerCase() === 'inseam' && val.indexOf('"') > 0) {
                        filterLink = $('.refinements:not(.d-none)').children().not('#active-filters').find('[data-filter-id="' + filterType + '"][data-filter-value^="' + val.replace(/['"]+/g, '') + '\\""]');
                    } else {
                        filterLink = $('.refinements:not(.d-none)').children().not('#active-filters').find('[data-filter-id="' + filterType + '"][data-filter-value="' + val + '"]');
                    }
                    if (filterLink !== undefined && filterLink.length > 0) {
                        var buttonElement;
                        if (filterType.toLowerCase() === 'inseam' && val.indexOf('"') > 0) {
                            buttonElement = '<a href="' + filterLink.attr('href') + '" data-hrefurl="' + filterLink.data('hrefurl') + '" data-filter-name="' + filterLink.data('filter-name') + '" data-refinementurl="' + filterLink.data('refinementurl') + '"  data-filter-id="' + filterLink.data('filter-id') + '" data-filter-type="' + filterLink.data('filter-type') + '" data-filter-value="' + filterLink.data('filter-value').replace('"', '') + '&quot;" data-track-filter-value="' + filterLink.data('filter-value').replace('"', '') + '&quot;" >' + filterLink.data('filter-name') + ': ' + val + ' <svg class="icon icon-cross"><use xlink:href="#crossWhite"></use></svg></a>';
                        } else {
                            buttonElement = '<a href="' + filterLink.attr('href') + '" data-hrefurl="' + filterLink.data('hrefurl') + '" data-filter-name="' + filterLink.data('filter-name') + '" data-refinementurl="' + filterLink.data('refinementurl') + '"  data-filter-id="' + filterLink.data('filter-id') + '" data-filter-type="' + filterLink.data('filter-type') + '" data-filter-value="' + filterLink.data('filter-value') + '" data-track-filter-value="' + filterLink.data('track-filter-value') + '" >' + filterLink.data('filter-name') + ': ' + val + ' <svg class="icon icon-cross"><use xlink:href="#crossWhite"></use></svg></a>';
                        }
                        $('.suggested-filters .filters').append(buttonElement);
                    }
                });
            }
        });
        $('.suggested-filters').find('a').each(function () {
            var filteredURL;
            if ($(this).attr('data-filter-type').toLowerCase() === 'inseam' && $(this).attr('data-filter-value').indexOf('"') > 0) {
                filteredURL = $('.refinements:not(.d-none) [data-filter-type="' + $(this).attr('data-filter-type') + '"][data-filter-value="' + $(this).attr('data-filter-value').replace(/['"]+/g, '') + '\\""]');
            } else {
                filteredURL = $('.refinements:not(.d-none) [data-filter-type="' + $(this).attr('data-filter-type').charAt(0).toUpperCase() + $(this).attr('data-filter-type').slice(1) + '"][data-filter-value="' + $(this).attr('data-filter-value') + '"]');
            }
            if ($(filteredURL).length !== 0) {
                $(this).removeClass('d-none');
                $(this).attr('href', $(filteredURL).attr('href'));
                $(this).attr('data-hrefurl', $(filteredURL).data('hrefurl'));
                $(this).attr('data-refinementurl', $(filteredURL).data('refinementurl'));
            } else {
                $(this).addClass('d-none');
            }
        });
        $('.suggested-filters').find('a').removeClass('selected');
        $('#active-filters-list .filtered-item:not(.d-none)').each(function () {
            if ($(this).find('a').data('filter-id') === 'size') {
                $('.suggested-filters').find('a[data-filter-value="' + $(this).find('a').data('filter-value') + '"]').addClass('selected');
            } else if ($(this).find('a').data('filter-id').toLowerCase() === 'inseam' && $(this).find('.selected-filter').text().split(':')[1].trim().indexOf('"') > 0) {
                $('.suggested-filters').find('a[data-filter-value="' + $(this).find('.selected-filter').text().split(':')[1].trim().replace(/['"]+/g, '') + '\\""]').addClass('selected');
            } else {
                $('.suggested-filters').find('a[data-filter-value="' + $(this).find('.selected-filter').text().split(':')[1].trim().replace(/['"]+/g, '') + '"]').addClass('selected');
            }
        });

        var suggestedFilter = localStorage.getItem('browsedFilter_' + siteLanguage);
        var suggestedFilterStoredObj = JSON.parse(suggestedFilter);
        isfilteredPage = $('#retain-filter-attributes').attr('data-isfiltered');
        if ((isfilteredPage === 'true' && (existingSelectedFromPanel[selectedFromPanelCategory] === true))) {
            $('.suggested-filters').addClass('d-none');
        } else {
            if ($('#active-filters-list .filtered-item:not(.d-none)').length === 0) {
                existingSelectedFromPanel[selectedFromPanelCategory] = false;
            }
            $('.suggested-filters').find('a').css('order', '1');
            $('.suggested-filters').find('a:not(".selected")').each(function () {
                $(this).css('order', '2');
            });
            localStorage.setItem('browsedFilter_' + siteLanguage, JSON.stringify(suggestedFilterStoredObj));
            sessionStorage.setItem('selectedFromPanelGroup_' + siteLanguage, JSON.stringify(existingSelectedFromPanel));
        }
    }
    if (!($('.purchased-suggested-filters .filters').is(':empty'))) {
        if ($('#active-filters-list .filtered-item:not(.d-none)').length === 0) {
            existingSelectedFromPanel[selectedFromPanelCategory] = false;
        }
        sessionStorage.setItem('selectedFromPanelGroup_' + siteLanguage, JSON.stringify(existingSelectedFromPanel));
        $('.purchased-suggested-filters').find('a').each(function () {
            var filteredURL = $('.refinements:not(.d-none) [data-filter-type="' + $(this).attr('data-filter-type').charAt(0).toUpperCase() + $(this).attr('data-filter-type').slice(1) + '"][data-filter-value="' + $(this).attr('data-filter-value') + '"]');
            if ($(filteredURL).length !== 0) {
                $(this).removeClass('d-none');
                $(this).attr('href', $(filteredURL).attr('href'));
                $(this).attr('data-hrefurl', $(filteredURL).data('hrefurl'));
                $(this).attr('data-refinementurl', $(filteredURL).data('refinementurl'));
            } else {
                $(this).addClass('d-none');
            }
        });

        $('.purchased-suggested-filters').find('a').removeClass('selected');
        $('#active-filters-list .filtered-item:not(.d-none)').each(function () {
            $('.purchased-suggested-filters').find('a[data-filter-value="' + $(this).find('a').data('filter-value') + '"]').addClass('selected');
        });
        $('.purchased-suggested-filters').find('a').css('order', '1');
        $('.purchased-suggested-filters').find('a:not(".selected")').each(function () {
            $(this).css('order', '2');
        });
        if ($('.purchased-suggested-filters').find('a.selected').length > 0) {
            $('.applied-filters').trigger('click');
        }

        if ($('.suggested-filters').find('a.selected').length > 0) {
            $('.applied-filters').trigger('click');
        }
    }

    if ($('#active-filters-list .filtered-item:not(.d-none)').length === 0 && ($('.suggested-filters').hasClass('d-none') && $('.purchased-suggested-filters').hasClass('d-none'))) {
        $('.mobCatFilters').removeClass('d-none');
    } else {
        $('.mobCatFilters').addClass('d-none');
    }

    if ($('.suggested-filters').hasClass('d-none') && $('.purchased-suggested-filters').hasClass('d-none')) {
        $('.mobFilterPills').removeClass('d-none');
    } else {
        $('.mobFilterPills').addClass('d-none');
    }

    $('.applied-filters').off('click').trigger('click');
}
/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };
    if (selectedSizes && window.ffCdpOOSProduct) {
        updateOOSColorVariants($(response));
    }
    handleHeroBannerUpdate($results, '.refinement-hero-banner', false);
    handleVisualQuickLinksUpdate($results, '.refinement-visuallinks', false);
    // Update DOM elements that do not require special handling
    [
        '.grid-header-inner',
        '.content-grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.filter-header',
        '.nav-tabs-wrapper',
        '.sort-wrapper',
        '.dataLayer',
        '.size-chart',
        '.no-search-results-js',
        '.category-visual-link-slot',
        '.seo-content-update',
        '.seo-bottom-content-update',
        '.breadcrumb',
        '.einstein-recommender',
        '.ai-recommender'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });
    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}
/**
 * Updates the refinement url after page sorting.
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateRefinementsPostSorting(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };
    if ($results) {
        Object.keys(specialHandlers).forEach(function (selector) {
            specialHandlers[selector]($results);
        });
    }

    $('.mobFilterPills .filter-pills-wrapper').html($('.refinements .active-filter-list').html());
    if (window.digitalData.page.category.pageType === 'cdp' && $('#retain-filter-attributes').length > 0 && storedfilteroptionsflag === 'true' && $('.retain-filter-wrapper').is(':visible')) {
        $('.applied-filters').trigger('click');
    }
}
/**
 * Filter click handler
 */
function filter() {
    baseSearch.filter = function () {
        $('button.filter-results').off('click');
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            recommendedFilters = false;
            $('.refinement-bar, .modal-background').addClass('show');
            $('body').addClass('filters-modal');
            $('.refinement-bar .refinements').focus();
            // for keyboard events
            $('.refinement-bar button.view-items-btn').on('keydown', function (event) {
                if (event.key === 'Tab') {
                    event.preventDefault();
                    $('.refinement-bar .close').focus();
                }
            });
            $('.refinement-bar .close').on('keydown', function (event) {
                if (event.key === 'Tab') {
                    if (event.shiftKey) {
                        event.preventDefault();
                        $('.refinement-bar button.view-items-btn').focus();
                    }
                }
            });
            // For mobile events
            $('.refinement-bar button').on('touchstart', function (event) {
                startX = event.originalEvent.touches[0].clientX; // Get the starting X position
            });

            // Touch end event to determine swipe direction
            $('.refinement-bar button').on('touchend', function (event) {
                const endX = event.changedTouches[0].clientX; // Get the ending X position
                const swipeThreshold = 30; // Minimum distance to consider a swipe

                if (Math.abs(endX - startX) > swipeThreshold) {
                    if (endX < startX) {
                        // Swipe Left
                        if ($(this).hasClass('view-items-btn')) {
                            $('.refinement-bar .close').focus(); // Move focus to close button
                        }
                    } else if ($(this).hasClass('close')) { // Swipe Right
                        $('.refinement-bar button.view-items-btn').focus(); // Move focus to view items button
                    }
                }
            });
        });
    };
}

/**
 * Close refinments click handler
 */
function closeRefinments() {
    $('.refinement-bar button.close, .modal-background').off('click');
    baseSearch.closeRefinments = function () {
        // Refinements close button
        $('.container').on(
            'click',
            '.refinement-bar button.close, .modal-background',
            function (event) {
                event.preventDefault(); // Prevent default behavior
                event.stopPropagation(); // Stop event bubbling
                $('.refinement-bar, .modal-background').removeClass('show');
                $('body').removeClass('filters-modal');
                if ($('.site-stripe-wrapper .slick-next')) {
                    // Preventing focus going to slick next of header banner
                    $('.site-stripe-wrapper .slick-next').attr('aria-hidden', 'true');
                }
                $('button.filter-results').focus();
            }
        );
    };
}

/**
 * Close refinments click handler
 */
function viewItems() {
    $('.refinement-bar button.view-items-btn, .modal-background').off('click');
    baseSearch.viewItems = function () {
        // Refinements close button
        $('.container').on(
            'click',
            '.refinement-bar button.view-items-btn, .modal-background',
            function () {
                $('.refinement-bar, .modal-background').removeClass('show');
                $('body').removeClass('filters-modal');
            }
        );
    };
}

/**
 * Update the digital data fields after the page load.
 */
function updateDigitalData() {
    if (window.digitalData && window.digitalData.page && window.digitalData.page.attributes) {
        var pageAttributes = window.digitalData.page.attributes;
        if (pageAttributes.cdp && pageAttributes.cdp.term !== $.cookie('searchTerm')) {
            window.digitalData.page.attributes.cdp.term = $.cookie('searchTerm');
            delete $.cookie('searchTerm');
        } else if (pageAttributes.search && pageAttributes.search.term !== $.cookie('searchTerm')) {
            window.digitalData.page.attributes.search.term = $.cookie('searchTerm');
            delete $.cookie('searchTerm');
        }
    }
}

/**
 * Initiate facets expand collapse feature by adding session storage object
 */
function initExpandedFacets() {
    if (window.sessionStorage && !sessionStorage.expandedFacets) {
        var expandedFacets = {};
        $('.refinements .refinement').each(function (key, val) {
            expandedFacets[$(val).attr('id')] = 'false';
        });
        sessionStorage.setItem('expandedFacets', JSON.stringify(expandedFacets));
    }
}

/**
 * Handle Guest Insight Recommender on document ready
 * This function fetches guest insight recommendations from the API and updates the DOM.
 * If the API URL is not available, it removes the recommender element from the DOM.
 */
function handleGuestInsightRecomm() {
    var guestInsightRecomm = $('.guest-insight-recomm-js');
    if (guestInsightRecomm.length > 0) {
        var guestInsightRecommUrl = guestInsightRecomm.data('recomm-api');
        if (guestInsightRecommUrl) {
            $.ajax({
                url: guestInsightRecommUrl,
                type: 'GET',
                success: function (response) {
                    if (response && response.length > 0) {
                        guestInsightRecomm.html(response);
                        setTimeout(() => {
                            if (!guestInsightRecomm.find('.product-carousel').hasClass('slick-initialized')) {
                                carouselInit.initProductCarousel();
                                var $swatches = $('.recommendations .guest-insight-recomm-js .swatches');
                                productTile.initSwatch($swatches);
                            }
                        }, 500);
                    }
                }
            });
        } else {
            guestInsightRecomm.remove();
        }
    }
}
/**
 * Updating facets expand collapse feature when clicking on it
 */
function handelExpandedFacets() {
    if (window.sessionStorage) {
        var expandedFacetsObj = JSON.parse(sessionStorage.expandedFacets);
        expandedFacetsObj['active-filters'] = 'true';
        $.each(expandedFacetsObj, function (key, valueObj) {
            var className = '.refinement-' + key;
            if (valueObj === 'false') {
                $(className).removeClass('active');
            } else {
                $(className).addClass('active');
            }
        });

        $('.refinement .card-header').on('click', function () {
            if (window.sessionStorage) {
                var activeFlag;
                if ($(this).parent('.refinement').hasClass('active')) {
                    $('.refinement .card-header').attr('aria-expanded', 'false');
                    activeFlag = 'false';
                } else {
                    $('.refinement .card-header').attr('aria-expanded', 'true');
                    activeFlag = 'true';
                }
                expandedFacetsObj[$(this).parents('.refinement').attr('id')] = activeFlag;
                sessionStorage.expandedFacets = JSON.stringify(expandedFacetsObj);
            }
        });
    }
}

/**
 * Initialize the recommended category filters for mobile
 */
function initCategoryFilters() {
    $('.cat-mob-filter').off().on('click', function () {
        recommendedFilters = true;
        $('.refinement-bar, .modal-background').addClass('show');
        $('body').addClass('filters-modal');
        var refinement = '#' + $(this).data('refinement');
        var $filter = $('.refinements').find(refinement);
        if (!$($filter[0]).hasClass('active')) {
            $($filter[0]).addClass('active');
        }
        $(refinement).get(0).scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    });
}

/**
 * This function applies the lead color on selection of color filter and also
 * moves the OOS color variants to the end of the swatch list.
 */
function handleSelectedColorSizeFeatures() {
    var searchURL = null;
    var search;
    // Find the non-seo (show-ajax) url for the selected color/size filter. This is stored in active filters in data-refinedattributevalueurl attribute.
    if ($('#active-filters-list').find('[data-filtertype="color"]') && $('#active-filters-list').find('[data-filtertype="color"]').length) {
        searchURL = $('#active-filters-list').find('[data-filtertype="color"]').attr('data-refinedattributevalueurl');
    } else if ($('#active-filters-list').find('[data-filtertype="size"]') && $('#active-filters-list').find('[data-filtertype="size"]').length) {
        searchURL = $('#active-filters-list').find('[data-filtertype="size"]').attr('data-refinedattributevalueurl');
    }
    if (searchURL) {
        searchURL = new URL(location.origin + searchURL);
        search = searchURL.search;
    }
    if (searchURL && search !== '') {
        var urlParams = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === '' ? value : decodeURIComponent(value); });
        urlParams = Object.entries(urlParams);
        var sizeParamsFlag = false;
        var colorParmsFlag = false;
        var colorsInUrl;
        var lastSelectedColor;
        var paramPos;
        for (const [key, value] of urlParams) {
            if (value === 'size' && window.ffCdpOOSProduct) {
                sizeParamsFlag = true;
                paramPos = key.split('prefn')[1];
                for (var i = 0; i < urlParams.length; i++) {
                    if (urlParams[i][0] === 'prefv' + paramPos) {
                        selectedSizes = urlParams[i][1];
                        if (selectedSizes && selectedSizes.indexOf('|') > -1) {
                            selectedSizes = selectedSizes.replaceAll('|', ',');
                            break;
                        }
                    }
                }
            }
            if (value === 'refinementColor') {
                colorParmsFlag = true;
                paramPos = key.split('prefn')[1];
                for (var j = 0; j < urlParams.length; j++) {
                    if (urlParams[j][0] === 'prefv' + paramPos) {
                        colorsInUrl = urlParams[j][1];
                        if (colorsInUrl && colorsInUrl.indexOf('|') > -1) {
                            colorsInUrl = colorsInUrl.replaceAll('|', ',');
                            break;
                        }
                    }
                }
                if (colorsInUrl && colorsInUrl.indexOf(',') > -1) {
                    var colorsInUrlArray = colorsInUrl.split(',');
                    lastSelectedColor = colorsInUrlArray[colorsInUrlArray.length - 1];
                } else {
                    lastSelectedColor = colorsInUrl;
                }
                if (lastSelectedColor) {
                    selectedColors = $('#refinementcolor [data-filter-value=' + lastSelectedColor + ']').attr('data-leadcolorselector');
                }
            }
        }

        if (sizeParamsFlag && selectedSizes) {
            updateOOSColorVariants($('.product-grid'));
        }
        if (colorParmsFlag && selectedColors) {
            handleColorFilterLeadColor($('.product-grid'));
        }
    }
}

/**
 * Add Aria attributes for the filters
 */
function addAriaAttirbutes() {
    const refinements = document.querySelectorAll('.refinements .card');
    refinements.forEach(card => {
        const isActive = card.classList.contains('active');
        const cardHeader = card.querySelector('.card-header');
        if (cardHeader) {
            cardHeader.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
    });
}
/**
 * IsAndroid to detect if the user is on an Android device
 * @return {boolean} - Compiled HTML
 */
function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

/**
 * Function to detect if the user is on an IOS device
 * @return {boolean} - Compiled HTML
*/
function isIos() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}


/**
 * Add Aria attributes for the filters based on device.
 */
function addFilterAriaAttirbutes() {
    const refinements = document.querySelectorAll('.refinements');
    const refinementsBar = document.querySelectorAll('.refinement-bar');
    if (isAndroid() || isIos()) {
        refinements.forEach(refinement => {
            refinement.setAttribute('aria-modal', 'true');
            refinement.setAttribute('role', 'dialog');
            refinement.setAttribute('tabindex', '0');
        });
        refinementsBar.forEach(refinementItem => {
            refinementItem.setAttribute('aria-modal', 'true');
            refinementItem.setAttribute('role', 'dialog');
            refinementItem.setAttribute('tabindex', '0');
        });
    } else {
        refinements.forEach(refinement => {
            refinement.setAttribute('tabindex', '-1');
        });
        refinementsBar.forEach(refinementItem => {
            refinementItem.setAttribute('tabindex', '-1');
        });
    }
}

/**
 * Select the hybrid size tab that was previously selected
 */
function handleHybridSizeTab() {
    if (window.sessionStorage.getItem('currentHybridSizeTab')) {
        var activeTab = $('.hybrid-size-tabs-ul .nav-item').find('[title="' + window.sessionStorage.getItem('currentHybridSizeTab') + '"]:not(.d-none)').length ? $('.hybrid-size-tabs-ul .nav-item').find('[title="' + window.sessionStorage.getItem('currentHybridSizeTab') + '"]') : $('.hybrid-size-tabs-ul .nav-item').find('[title="US"]');
        if (activeTab.length) {
            activeTab.trigger('click');
        }
    }
}

/**
 * Show suggested filters.
 */
function showSuggestedFilters() {
    var suggestedFilter = localStorage.getItem('browsedFilter_' + siteLanguage);
    var selectedFromPanelGroup;
    if (sessionStorage.getItem('selectedFromPanelGroup_' + siteLanguage)) {
        selectedFromPanelGroup = JSON.parse(sessionStorage.getItem('selectedFromPanelGroup_' + siteLanguage));
    }

    if (storedfilteroptionsflag === 'true') {
        if (selectedFromPanelGroup === undefined) {
            selectedFromPanelGroup = {};
            selectedFromPanelGroup[selectedFromPanelCategory] = false;
            sessionStorage.setItem('selectedFromPanelGroup_' + siteLanguage, JSON.stringify(selectedFromPanelGroup));
        }
        var storedfiltertypes = $('#retain-filter-attributes').attr('data-refinementtypetostore').split(',');
        if (suggestedFilter === null || JSON.parse(suggestedFilter)[suggestedFilterobjType] === undefined) {
            var suggestedFilterobjTypeobj;
            let storedBrowedFilter = JSON.parse(localStorage.getItem('browsedFilter_' + siteLanguage));
            if (storedBrowedFilter === null) {
                storedBrowedFilter = {};
                storedBrowedFilter[suggestedFilterobjType] = {
                    filters: {}
                };
                for (var i = 0; i < storedfiltertypes.length; i++) {
                    storedBrowedFilter[suggestedFilterobjType].filters[storedfiltertypes[i]] = [];
                }
            } else {
                suggestedFilterobjTypeobj = {
                    filters: {}
                };
                for (var j = 0; j < storedfiltertypes.length; j++) {
                    suggestedFilterobjTypeobj.filters[storedfiltertypes[j]] = [];
                }
                storedBrowedFilter[suggestedFilterobjType] = suggestedFilterobjTypeobj;
            }
            // Put the object into storage
            localStorage.setItem('browsedFilter_' + siteLanguage, JSON.stringify(storedBrowedFilter));
        } else {
            var storedFilteredObj = JSON.parse(suggestedFilter);
            localStorage.setItem('browsedFilter_' + siteLanguage, JSON.stringify(storedFilteredObj));
            var storedFilteredObjTypes = storedFilteredObj[suggestedFilterobjType].filters;
            Object.keys(storedFilteredObjTypes).forEach(filterType => {
                if (storedFilteredObjTypes[filterType].length !== 0) {
                    storedFilteredObjTypes[filterType].forEach((val) => {
                        var filterLink;
                        if (filterType === 'size') {
                            filterLink = $('.refinements:not(.d-none) [data-filter-id="' + filterType + '"] [data-localizedsize="' + val + '"]').parents('a');
                        } else if (filterType.toLowerCase() === 'inseam' && val.indexOf('"') > 0) {
                            filterLink = $('.refinements:not(.d-none) [data-filter-id="' + filterType + '"][data-filter-value="' + val.replace(/['"]+/g, '') + '\\""]');
                        } else {
                            filterLink = $('.refinements:not(.d-none) [data-filter-id="' + filterType + '"][data-filter-value="' + val + '"]');
                        }
                        if (filterLink !== undefined && filterLink.length > 0) {
                            var buttonElement;
                            if (filterType.toLowerCase() === 'inseam' && val.indexOf('"') > 0) {
                                buttonElement = '<a href="' + filterLink.attr('href') + '" data-hrefurl="' + filterLink.data('hrefurl') + '" data-filter-name="' + filterLink.data('filter-name') + '" data-refinementurl="' + filterLink.data('refinementurl') + '"  data-filter-id="' + filterLink.data('filter-id') + '" data-filter-type="' + filterLink.data('filter-type') + '" data-filter-value="' + filterLink.data('filter-value').replace('"', '') + '&quot;" data-track-filter-value="' + filterLink.data('filter-value').replace('"', '') + '&quot;" >' + filterLink.data('filter-name') + ': ' + val + ' <svg class="icon icon-cross"><use xlink:href="#crossWhite"></use></svg></a>';
                            } else {
                                buttonElement = '<a href="' + filterLink.attr('href') + '" data-hrefurl="' + filterLink.data('hrefurl') + '" data-filter-name="' + filterLink.data('filter-name') + '" data-refinementurl="' + filterLink.data('refinementurl') + '"  data-filter-id="' + filterLink.data('filter-id') + '" data-filter-type="' + filterLink.data('filter-type') + '" data-filter-value="' + filterLink.data('filter-value') + '" data-track-filter-value="' + filterLink.data('track-filter-value') + '" >' + filterLink.data('filter-name') + ': ' + val + ' <svg class="icon icon-cross"><use xlink:href="#crossWhite"></use></svg></a>';
                            }
                            $('.suggested-filters .filters').append(buttonElement);
                        }
                    });
                }
            });
            if ($('.suggested-filters a').length > 0 && $('.purchased-suggested-filters .filters').is(':empty')) {
                $('.suggested-filters').removeClass('d-none');
            }
        }
    }

    if (localStorage.getItem('purchasedFilter_' + siteLanguage)) {
        $('.suggested-filters').addClass('d-none');
        var storedpurchasedFilterObj = JSON.parse(localStorage.getItem('purchasedFilter_' + siteLanguage));
        if (storedpurchasedFilterObj[l2Category] !== undefined) {
            Object.keys(storedpurchasedFilterObj[l2Category]).forEach(filterpurchasedType => {
                var filterLink;
                var colorName;
                var buttonElement;
                if (filterpurchasedType === 'refinementColor') {
                    $('#refinementcolor a[data-filter-id="refinementColor"]').each(function () {
                        storedpurchasedFilterObj[l2Category][filterpurchasedType].forEach((val) => {
                            if (val.toLowerCase().indexOf($(this).attr('data-track-filter-value').split('_')[0]) >= 0 || $(this).attr('data-track-filter-value').split('_')[0].indexOf(val.toLowerCase()) >= 0) {
                                filterLink = $(this);
                                colorName = $(this).attr('data-filter-value');
                                if (filterLink !== undefined && filterLink.length > 0) {
                                    buttonElement = '<a href="' + filterLink.attr('href') + '" data-hrefurl="' + filterLink.data('hrefurl') + '" data-filter-name="' + filterLink.data('filter-name') + '" data-refinementurl="' + filterLink.data('refinementurl') + '" data-filter-id="' + filterLink.data('filter-id') + '" data-filter-type="' + filterLink.data('filter-type') + '" data-filter-value="' + filterLink.data('filter-value') + '" data-track-filter-value="' + filterLink.data('track-filter-value') + '" >' + filterLink.data('filter-name') + ': ' + colorName + ' <svg class="icon icon-cross"><use xlink:href="#crossWhite"></use></svg></a>';
                                    $('.purchased-suggested-filters .filters').append(buttonElement);
                                    $('.purchased-suggested-filters').removeClass('d-none');
                                }
                            }
                        });
                        return true;
                    });
                } else {
                    storedpurchasedFilterObj[l2Category][filterpurchasedType].forEach((val) => {
                        filterLink = $('.refinements:not(.d-none) [data-filter-id="' + filterpurchasedType + '"][data-filter-value="' + val + '"]');
                        if (filterLink !== undefined && filterLink.length > 0) {
                            buttonElement = '<a href="' + filterLink.attr('href') + '" data-hrefurl="' + filterLink.data('hrefurl') + '" data-filter-name="' + filterLink.data('filter-name') + '" data-refinementurl="' + filterLink.data('refinementurl') + '" data-filter-id="' + filterLink.data('filter-id') + '" data-filter-type="' + filterLink.data('filter-type') + '" data-filter-value="' + filterLink.data('filter-value') + '" data-track-filter-value="' + filterLink.data('track-filter-value') + '" >' + filterLink.data('filter-name') + ': ' + filterLink.find('.localizedsizevalue').text() + ' <svg class="icon icon-cross"><use xlink:href="#crossWhite"></use></svg></a>';
                            $('.purchased-suggested-filters .filters').append(buttonElement);
                            $('.purchased-suggested-filters').removeClass('d-none');
                        }
                    });
                }
            });
        }
    }
}

/**
 * Clean stored filter categories.
 */
function cleanStoredFilterCategories() {
    if (!JSON.parse(sessionStorage.getItem('intractedFiltersCleanupFlag'))) {
        var l2categoriestostored = $('#retain-filter-attributes').attr('data-l2categoriestostore').split(',');
        var existingSuggestedFilters = JSON.parse(localStorage.getItem('browsedFilter_' + siteLanguage));
        var storedTypesValues = $('#retain-filter-attributes').attr('data-refinementtypetostore').split(',');
        if (existingSuggestedFilters) {
            var keys = Object.keys(existingSuggestedFilters);
            keys.forEach(catid => {
                if (l2categoriestostored.indexOf(catid) < 0) {
                    delete existingSuggestedFilters[catid];
                } else {
                    var keysTypes = Object.keys(existingSuggestedFilters[catid].filters);
                    keysTypes.forEach(filterTypeid => {
                        if (storedTypesValues.indexOf(filterTypeid) < 0) {
                            delete existingSuggestedFilters[catid].filters[filterTypeid];
                        }
                    });
                    storedTypesValues.forEach(filterTypeid => {
                        if (existingSuggestedFilters[catid].filters[filterTypeid] === undefined) {
                            existingSuggestedFilters[catid].filters[filterTypeid] = [];
                        }
                    });
                }
            });

            // Put the object into storage
            localStorage.setItem('browsedFilter_' + siteLanguage, JSON.stringify(existingSuggestedFilters));
            sessionStorage.setItem('intractedFiltersCleanupFlag', true);
        }
    }
}

/**
 * Fetch filter suggestion based on purchased data.
 * @param {string} toUpdate - flag to update purchased data
 * @return {undefined}
 */
function getPurchasedFilterSuggestion(toUpdate) {
    if (!JSON.parse(sessionStorage.getItem('fetchedPurchasedFiltersFlag')) || toUpdate === 'true') {
        var getPurchasedFilterUrl = $('#retain-filter-attributes').data('getorupdatepurchaseddataurl');
        $.ajax({
            url: getPurchasedFilterUrl,
            type: 'post',
            dataType: 'json',
            data: { toUpdate: toUpdate, filterCategoryID: l2Category },
            success: function (res) {
                if (res.purchasedDataObject) {
                    localStorage.setItem('purchasedFilter_' + siteLanguage, JSON.stringify(res.purchasedDataObject));
                    sessionStorage.setItem('fetchedPurchasedFiltersFlag', true);
                } else if (res.purchaseDataUpdated) {
                    var existingPurchasedFilters = JSON.parse(localStorage.getItem('purchasedFilter_' + siteLanguage));
                    delete existingPurchasedFilters[l2Category];
                    localStorage.setItem('purchasedFilter_' + siteLanguage, JSON.stringify(existingPurchasedFilters));
                    $('.purchased-suggested-filters').addClass('d-none');
                    $('.purchased-suggested-filters .filters').empty();
                }
            }
        });
    }
}

$(document).ready(function () {
    initExpandedFacets();
    handelExpandedFacets();
    updateDigitalData();
    initCategoryFilters();
    handleHeroBannerUpdate($('.search-results'), '.refinement-hero-banner', true);
    handleVisualQuickLinksUpdate($('.search-results'), '.refinement-visuallinks', true);
    handleSelectedColorSizeFeatures();
    addFilterAriaAttirbutes();
    handleSizeFilter();
    if ($('.search-results').length > 0 && $('#retain-filter-attributes').length > 0) {
        var element = document.querySelector('.retain-filter-wrapper');
        if (window.IntersectionObserver) {
            var observer = new IntersectionObserver(function (entries) {
                if (entries[0].intersectionRatio && !retainFilterActivatedFlag) {
                    if (sessionStorage.getItem('intractedFiltersCleanupFlag') === null) {
                        sessionStorage.setItem('intractedFiltersCleanupFlag', false);
                    }
                    if ($('#guestUser').attr('data-isguestuser') === 'true') {
                        isRegisteredUser = false;
                    } else {
                        isRegisteredUser = true;
                    }
                    if (isRegisteredUser) {
                        if (sessionStorage.getItem('fetchedPurchasedFiltersFlag') === null) {
                            sessionStorage.setItem('fetchedPurchasedFiltersFlag', false);
                        }
                        getPurchasedFilterSuggestion('false');
                        cleanStoredFilterCategories();
                        setTimeout(function () {
                            showSuggestedFilters();
                            updateStoredFilterStatus();
                            if ($('.purchased-suggested-filters a').length !== 0) {
                                $('.mobCatFilters').addClass('d-none');
                            }
                            if ((isfilteredPage === 'true' && (existingSelectedFromPanel[selectedFromPanelCategory] === true))) {
                                $('.suggested-filters').addClass('d-none');
                            } else if ($('.suggested-filters').find('a').length > 0 && $('.purchased-suggested-filters .filters').is(':empty')) {
                                $('.suggested-filters').removeClass('d-none');
                            }
                        }, 800);
                    } else {
                        if ((isfilteredPage === 'true' && (existingSelectedFromPanel[selectedFromPanelCategory] === true))) {
                            $('.suggested-filters').addClass('d-none');
                        } else if ($('.suggested-filters').find('a').length > 0 && $('.purchased-suggested-filters .filters').is(':empty')) {
                            $('.suggested-filters').removeClass('d-none');
                        }
                        cleanStoredFilterCategories();
                        showSuggestedFilters();
                        updateStoredFilterStatus();
                        if (localStorage.getItem('purchasedFilter_' + siteLanguage)) {
                            localStorage.removeItem('purchasedFilter_' + siteLanguage);
                        }
                        sessionStorage.setItem('fetchedPurchasedFiltersFlag', false);
                        if ($('.suggested-filters a').length !== 0) {
                            $('.mobCatFilters').addClass('d-none');
                        }
                    }
                    const el = document.querySelector('.grid-header.sticky-top');
                    window.addEventListener('scroll', () => {
                        const stickyTop = parseInt(window.getComputedStyle(el).top, 10);
                        const currentTop = el.getBoundingClientRect().top;
                        el.classList.toggle('is-sticky', currentTop === stickyTop);
                    });
                    retainFilterActivatedFlag = true;
                }
            }, {
                root: document.body
            });
            observer.observe(element);
        }
    }

    if ($('.guest-insight-recomm-js').length > 0) {
        handleGuestInsightRecomm();
    }
});

/**
 * Resize handler
 */
function resize() {
    baseSearch.resize = function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            if (!mobileMediaQuery.matches) {
                $('.refinement-bar, .modal-background').removeClass('show');
                $('body').removeClass('filters-modal');
            }
        });
    };
}

/**
 * CDP Show Loader
 */
function showLoader() {
    $('.cdp-loader').removeClass('hide').attr('aria-busy', 'true');
    $('body').addClass('modal-with-backdrop');
    setTimeout(function () {
        $('.cdp-loader')[0].focus();
    }, 100);
}

/**
 * CDP Hide Loader
 */
function hideLoader() {
    $('.cdp-loader').addClass('hide').attr('aria-busy', 'false');
    $('body').removeClass('modal-with-backdrop');
}


/**
 * Validate input values for price filters
 *  @returns {boolean} if valid or not
 */
function isInputValid() {
    var min = $('#min-amount').val();
    var max = $('#max-amount').val();

    let isValid = true;
    var $errorMsgEle = $('.range-error-msg');

    $errorMsgEle.text('');
    $('.price-input-field').removeClass('invalid');
    $('.close-icon').css('display', 'none');

    // Check if fields are empty
    if (min === '' && max === '') {
        $errorMsgEle.text($errorMsgEle.data('empty-fields-err'));
        $('.price-input-field').addClass('invalid');
        isValid = false;
    } else if (min === '' && max !== '') {
        $errorMsgEle.text($errorMsgEle.data('no-min-err'));
        $('#min-amount').addClass('invalid');
        isValid = false;
    } else if (max === '' && min !== '') {
        $errorMsgEle.text($errorMsgEle.data('no-max-err'));
        $('#max-amount').addClass('invalid');
        isValid = false;
    } else {
        const validChars = /^[0-9]+$/;

        if (!validChars.test(min)) {
            isValid = false;
            $('#min-amount').addClass('invalid').siblings('.close-icon').css('display', 'inline');
            $errorMsgEle.text($errorMsgEle.data('invalid'));
        }

        if (!validChars.test(max)) {
            isValid = false;
            $('#max-amount').addClass('invalid').siblings('.close-icon').css('display', 'inline');
            $errorMsgEle.text($errorMsgEle.data('invalid'));
        }

        if (parseFloat(min) > parseFloat(max)) {
            isValid = false;
            $('#min-amount').addClass('invalid').siblings('.close-icon').css('display', 'inline');
            $errorMsgEle.text($errorMsgEle.data('low-min-err'));
        }
    }

    if (isValid) {
        $('.price-input-field').removeClass('invalid');
        $('.close-icon').css('display', 'none');
    }
    // analytics
    if (typeof _satellite !== 'undefined' && !isValid) {
        _satellite.track('cdp-filter-interaction', {
            component: {
                id: 'cdp:price:manual-filter-error',
                filter: 'error price:' + min + '-' + max
            }
        });
    }


    return isValid;
}

/**
 * Updates price filter specific parameters in the given URL.
 *
 * @param {string} url - The URL in which the parameter should be updated.
 * @param {string} param - The name of the parameter(pmin/pmax) to update.
 * @param {string|number} value - The new value to set for the parameter.
 * @returns {string} - The updated URL with the parameter set to the new value.
 */
function updatePriceParameter(url, param, value) {
    var urlObj = new URL(url);
    var params = urlObj.searchParams;

    params.set(param, value);
    return urlObj.toString();
}

/**
 * Updates URL of the custom price filter by updating the pmin and pmax parameters in all the associated URLs
 *
 * @param {HTMLElement} anchor - The anchor element whose URLs will be updated with the custom filter parameters.
 */
function applyCustomFilter(anchor) {
    var pmin = $('#min-amount').val();
    var pmax = $('#max-amount').val();

    var urlSrule = $(anchor).attr('href').indexOf(location.origin) === -1 ? location.origin + $(anchor).attr('href') : $(anchor).attr('href');
    var urlSeo = $(anchor).attr('data-hrefurl').indexOf(location.origin) === -1 ? location.origin + $(anchor).attr('data-hrefurl') : $(anchor).attr('data-hrefurl');
    var urlRef = $(anchor).attr('data-refinementurl').indexOf(location.origin) === -1 ? location.origin + $(anchor).attr('data-refinementurl') : $(anchor).attr('data-refinementurl');

    // Update pmin and pmax parameters in the URL
    var updatedUrlSr = updatePriceParameter(urlSrule, 'pmin', pmin);
    updatedUrlSr = updatePriceParameter(updatedUrlSr, 'pmax', pmax);

    var updatedUrlSeo = updatePriceParameter(urlSeo, 'pmin', pmin);
    updatedUrlSeo = updatePriceParameter(updatedUrlSeo, 'pmax', pmax);

    var updatedUrlRef = updatePriceParameter(urlRef, 'pmin', pmin);
    updatedUrlRef = updatePriceParameter(updatedUrlRef, 'pmax', pmax);

    $(anchor).attr('href', updatedUrlSr);
    $(anchor).attr('data-hrefurl', updatedUrlSeo);
    $(anchor).attr('data-refinementurl', updatedUrlRef);

    if (typeof _satellite !== 'undefined') {
        _satellite.track('cdp-filter-interaction', {
            component: {
                id: 'cdp:price:manual-filter',
                filter: 'price:' + pmin + '-' + pmax
            }
        });
    }
}

/**
 * Removes a specified price parameter from a given URL.
 *
 * @param {string} url - The URL from which the price parameter should be removed.
 * @param {string} param - The name of the parameter to remove(pmin/pmax).
 * @returns {string|null} - Updated URL with the parameter removed, or null if the parameter does not exist.
 */
function removePriceParameter(url, param) {
    var urlObj = new URL(url);
    var params = urlObj.searchParams;

    params.delete(param);
    return urlObj.toString();
}

// Delete filter from the active filters section
$(document).on('click', '.custom-pill', function () {
    $('.clear-btn').click();
});

// Clear the input field when the close icon is clicked
$(document).on('click', '.close-icon', function () {
    $(this).closest('.input-group').find('input').val('');
    $(this).css('display', 'none');
});

$(document).on('keypress', '.price-input-field', function (event) {
    if (event.which === 13) {
        $('.apply-btn').click();
    }
});

/**
 * Removing commas and decimals from the price parameters to show in custom price filter region.
 *
 * @param {string} value - The number string to be cleaned.
 * @param {string} separator - The character used for grouping.
 * @param {string} decimal - The character used as a decimal point.
 * @returns {string} - The cleaned number string.
 */
function cleanNumberString(value, separator, decimal) {
    var updatedValue = value;
    if (updatedValue.indexOf(separator) !== -1) {
        updatedValue = updatedValue.replace(separator, '');
    }

    if (updatedValue.indexOf(decimal) !== -1) {
        updatedValue = updatedValue.split(decimal)[0];
    }

    return updatedValue;
}

/**
 * Populate price input fields and show custom filter pill on refresh and apply filter.
 */
function handleCustomPriceFilter() {
    if (location.search.indexOf('pmin') !== -1 && $('.refinements .priceCheck.checked').length === 0) {
        var urlParams = new URLSearchParams(location.search);
        var min = urlParams.get('pmin');
        var max = urlParams.get('pmax');

        var groupingChar = $('.range-form').attr('data-grouping-separator');
        var decimalChar = $('.range-form').attr('data-decimal-separator');

        min = cleanNumberString(min, groupingChar, decimalChar);
        max = cleanNumberString(max, groupingChar, decimalChar);

        // Populating input price fields
        $('#min-amount').val(min);
        $('#max-amount').val(max);

        var currencySymbol = $('.range-form').attr('data-currency-symbol');
        $('.no-filters').hide();
        $('.clear-filters').removeClass('d-none');
        var filterSpan = $('<span>', {
            class: 'custom-pill',
            text: currencySymbol + min + ' - ' + currencySymbol + max
        });


        var svg = '<svg class="crossIcon desktop"><use xlink:href="#crossWhite" /></use></svg>';
        var mobSvg = '<svg class="crossIcon mobile"><use xlink:href="#cross" /></use></svg>';
        filterSpan.append(svg).append(mobSvg);
        $('.active-filter-list').append(filterSpan);
        if (window.digitalData.page.category.pageType === 'cdp' && $('#retain-filter-attributes').length > 0 && storedfilteroptionsflag === 'true' && $('.retain-filter-wrapper').is(':visible')) {
            var filterLabel = $('.refinement-price').find('a').data('filter-name');
            var svgDesk = '<svg class="crossIcon"><use xlink:href="#crossWhite" /></use></svg>';
            var customfilterSpan = $('<span>', {
                class: 'custom-pill',
                text: filterLabel + ': ' + currencySymbol + min + ' - ' + currencySymbol + max
            });
            customfilterSpan.append(svgDesk);
            $('.mobFilterPills .filter-pills-wrapper').append(customfilterSpan);
            $('.mobCatFilters').addClass('d-none');
        }
    }
}
/**
 * This function saves the filter interaction of the user so that it can be suggested later.
 * @param {string} filterType - filter type
 * @param {string} filterTitle - filter title
 * @param {string} keyCategory - key caategory
 * @param {boolean} selectedFromPanelFlag - this flag identifies where the refinement is selected from.
 */
function saveForFilterSuggestion(filterType, filterTitle, keyCategory, selectedFromPanelFlag) {
    if (filterType !== undefined && filterTitle !== undefined) {
        var filterObj = {
            id: filterType + '_' + filterTitle,
            type: filterType,
            value: filterTitle
        };
        if (localStorage.getItem('browsedFilter_' + siteLanguage)) {
            var existingSuggestedFilters = JSON.parse(localStorage.getItem('browsedFilter_' + siteLanguage));
            var storedFilterType = existingSuggestedFilters[keyCategory].filters[filterObj.type];
            var storedObjType;
            if (storedFilterType !== undefined) {
                storedObjType = existingSuggestedFilters[keyCategory].filters[filterObj.type];
                var totalStoredCount = storedObjType.length;
                if (totalStoredCount < 2 && !storedObjType.includes(filterObj.value)) {
                    storedObjType.push(filterObj.value);
                } else if (totalStoredCount >= 2 && !storedObjType.includes(filterObj.value)) {
                    storedObjType.shift();
                    storedObjType.push(filterObj.value);
                }
            }
            existingSuggestedFilters[keyCategory].filters[filterObj.type] = storedObjType;
            existingSelectedFromPanel[selectedFromPanelCategory] = selectedFromPanelFlag;
            localStorage.setItem('browsedFilter_' + siteLanguage, JSON.stringify(existingSuggestedFilters));
            sessionStorage.setItem('selectedFromPanelGroup_' + siteLanguage, JSON.stringify(existingSelectedFromPanel));
        } else if (localStorage.getItem('purchasedFilter_' + siteLanguage) && isRegisteredUser) {
            existingSelectedFromPanel[selectedFromPanelCategory] = selectedFromPanelFlag;
            $('.purchased-suggested-filters').find('a[data-filter-value="' + filterObj.value + '"]').addClass('selected');
            $('.purchased-suggested-filters').find('a[data-filter-value="' + filterObj.value + '"]').css('order', '1');
            $('.purchased-suggested-filters').find('a[data-filter-value!="' + filterObj.value + '"]:not(".selected")').each(function () {
                $(this).css('order', '2');
            });
        }
    }
}

/**
 * See all for refinements
 */
function applyFilter() {
    baseSearch.applyFilter = function () {
        $(
            '.firstLevelFilter li a, .secondLevelFilter a, .mobFilterPills li a, .refinements li a, .refinement-bar a.reset, .filter-value a, .swatch-filter a, .suggested-filters a, .purchased-suggested-filters a'
        ).off('click');
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.firstLevelFilter li a, .secondLevelFilter a, .mobFilterPills li a,  .refinements li a:not(.hybrid-tab-link), .refinement-bar a.reset, .filter-value a, .swatch-filter a, a.apply-btn, a.clear-btn, .suggested-filters a, .purchased-suggested-filters a',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                var customPriceFilter = false;
                if (isCustomFilterEnabled) {
                    $('.no-product-notification').removeClass('displayed');
                    $('.other-products-header').removeClass('displayed');
                    // If custom price filter is used
                    if ($(e.target).hasClass('apply-btn')) {
                        customPriceFilter = true;
                        if (!isInputValid()) {
                            return;
                        }
                        applyCustomFilter(this);
                    }

                    // Clearing price filter
                    if ($(e.target).hasClass('clear-btn')) {
                        e.preventDefault();
                        var currURL = location.href;
                        if (currURL.indexOf('pmin') === -1) {
                            return;
                        }
                        var updatedUrl = removePriceParameter(currURL, 'pmin');
                        updatedUrl = removePriceParameter(updatedUrl, 'pmax');

                        $(this).attr('data-hrefurl', updatedUrl).attr('href', updatedUrl).attr('data-refinementurl', updatedUrl);
                    }
                }

                if ($('.hybrid-sizing-enabled').length) {
                    window.sessionStorage.setItem('currentHybridSizeTab', $('.hybrid-sizing-tab-section .nav-link.active').attr('title'));
                }

                showLoader();

                var pdPageWithQuickFilters = false;
                if (firstLevelFilterSelector.length > 0 || $('.secondLevelFilter').length > 0) {
                    pdPageWithQuickFilters = true;
                }
                if (!$(this).parents('.firstLevelFilter').length && !$(this).parents('.secondLevelFilter').length && !customPriceFilter && typeof _satellite !== 'undefined') {
                    var analyticsData = {
                        filterType: $(this).data('track-filter-type'),
                        filterValue: $(this).data('track-filter-value')
                    };

                    if (recommendedFilters) {
                        analyticsData.details = 'recommended';
                    }

                    if ($(this).parents('.retain-filter-wrapper').length || $(this).parents('#active-filters-list-mobile').length || $(this).parents('#active-filters-list').length) {
                        var filterTypeVal;
                        if ($(this).hasClass('selected')) {
                            filterTypeVal = 'remove-filter-' + $(this).data('filter-name');
                        } else {
                            filterTypeVal = $(this).data('filter-name');
                        }

                        if ($(this).parents('.retain-filter-wrapper').length) {
                            _satellite.track('filterInteraction', {
                                details: $(this).parents('.suggested-filters').length ? 'suggested-filter' : 'recent-purchase',
                                filterType: filterTypeVal,
                                filterValue: $(this).data('filter-value')
                            });
                        } else if ($(this).parents('#active-filters-list').length > 0 || $(this).parents('#active-filters-list-mobile').length > 0) {
                            _satellite.track('filterInteraction', {
                                filterType: 'remove-filter-' + $(this).data('filter-name'),
                                filterValue: $(this).data('filter-value')
                            });
                        }
                    } else {
                        _satellite.track('filterInteraction', analyticsData);
                    }
                }
                if (
                    window.ffCdpStatePersist &&
                    'URLSearchParams' in window &&
                    typeof history.pushState !== 'undefined'
                ) {
                    let sizeValue;
                    let defaultSizeValue = 12;
                    let newRelativePathQuery;
                    if ($('.promo-tile-element').length > 0 && $('.grid-footer').data('only-second-promo') !== true) {
                        defaultSizeValue = 10;
                    }
                    sizeValue = defaultSizeValue;
                    if ($(this).attr('data-hrefurl')) {
                        if ($(this).data('hrefurl').indexOf(location.origin) > -1) {
                            newRelativePathQuery = new URL($(this).attr('data-hrefurl'));
                            if (isCustomFilterEnabled && customPriceFilter) {
                                newRelativePathQuery = new URL($(this).attr('data-hrefurl'));
                            }
                        } else {
                            newRelativePathQuery = new URL(location.origin + $(this).attr('data-hrefurl'));
                        }
                        if (sizeValue) {
                            newRelativePathQuery.searchParams.set('sz', sizeValue);
                        }
                        if (newRelativePathQuery) {
                            history.pushState(null, '', newRelativePathQuery);
                        }
                    }
                }

                if (window.digitalData.page.category.pageType === 'cdp' && $('#retain-filter-attributes').length > 0 && storedfilteroptionsflag === 'true' && $('.retain-filter-wrapper').is(':visible')) {
                    // Logic for saving filters for suggestions.
                    var L1orL2Category;
                    var selectedFromPanel;
                    L1orL2Category = window.digitalData.page.category.subCategory1 ? window.digitalData.page.category.subCategory1 : window.digitalData.page.category.primaryCategory;
                    siteLanguage = window.digitalData.page.pageInfo.language ? window.digitalData.page.pageInfo.language.split('-')[0] : null;

                    if ($(this).parents('.refinement-bar').length > 0 || $(this).parents('.firstLevelFilter').length > 0) {
                        selectedFromPanel = true;
                    } else {
                        selectedFromPanel = false;
                    }

                    if (isRegisteredUser && selectedFromPanel) {
                        getPurchasedFilterSuggestion('true');
                    }

                    if ($(this).data('filter-id') === 'size') {
                        saveForFilterSuggestion($(this).data('filter-id'), $(this).find('.localizedsizevalue').data('localizedsize'), L1orL2Category, selectedFromPanel);
                    } else if ($(this).hasClass('custom-price-apply-btn')) {
                        saveForFilterSuggestion($(this).parents('.card-body ').find('a').eq(0)
                        .data('filter-id'), $(this).parents('.card-body ').find('#min-amount').val() + '-' + $(this).parents('.card-body ').find('#max-amount').val(), L1orL2Category, selectedFromPanel);
                    } else {
                        saveForFilterSuggestion($(this).data('filter-id'), $(this).data('filter-value'), L1orL2Category, selectedFromPanel);
                    }
                }

                var filterUrl;
                if ($(this).data('refinementurl')) {
                    if ($(this).data('refinementurl').indexOf(location.origin) > -1) {
                        filterUrl = new URL($(this).data('refinementurl'));
                    } else {
                        filterUrl = new URL(location.origin + $(this).data('refinementurl'));
                    }
                } else {
                    filterUrl = new URL(location.origin + $(this).data('refinementurl'));
                }
                var filterUrlSearchParams = filterUrl.searchParams;
                var searchParamsValuesEntries = filterUrlSearchParams.entries();
                var sizePreference = '';
                var colorPreference = '';
                for (const [key, value] of searchParamsValuesEntries) {
                    if (value === 'size') {
                        sizePreference = key;
                    }
                    if (value === 'refinementColor') {
                        colorPreference = key;
                    }
                }
                var sizePreferenceValue = filterUrlSearchParams.get('prefv' + sizePreference.split('prefn')[1]);
                if (sizePreferenceValue && sizePreferenceValue.indexOf('|') > -1) {
                    sizePreferenceValue = sizePreferenceValue.replaceAll('|', ',');
                }
                selectedSizes = sizePreferenceValue;
                var colorPreferenceValue = filterUrlSearchParams.get('prefv' + colorPreference.split('prefn')[1]);
                var lastSelectedColor;
                if (colorPreferenceValue && colorPreferenceValue.indexOf('|') > -1) {
                    colorPreferenceValue = colorPreferenceValue.replaceAll('|', ',').split(',');
                    lastSelectedColor = colorPreferenceValue[colorPreferenceValue.length - 1];
                    selectedColors = $('#refinementcolor [data-filter-value="' + lastSelectedColor + '"]').attr('data-leadcolorselector');
                } else {
                    selectedColors = $('#refinementcolor [data-filter-value="' + colorPreferenceValue + '"]').attr('data-leadcolorselector');
                }

                var mobile = false;
                if (mobileMediaQuery.matches) {
                    mobile = true;
                }
                var currentURL;
                if ($(this).data('hrefurl').indexOf(location.origin) > -1) {
                    currentURL = $(this).data('hrefurl');
                } else {
                    currentURL = location.origin + $(this).data('hrefurl');
                }
                currentURL = e.currentTarget.getAttribute('data-refinementurl') || currentURL;
                $.spinner().start();

                // reload the page when category filter selected
                if ($(this).data('filter-type') === 'category') {
                    window.location.reload();
                }

                $(this).trigger('search:filter', e);
                var targetApplyFilterLink = $(this);

                $.ajax({
                    url: currentURL,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: currentURL,
                        mobileDevice: mobile,
                        pdPageWithQuickFilters: pdPageWithQuickFilters
                    },
                    method: 'GET',
                    success: function (response) {
                        if (isCustomFilterEnabled && response.error) { // If invalid custom price filter is applied show error message
                            $.spinner().stop();
                            hideLoader();
                            if (customPriceFilter) {
                                $('.no-product-notification').addClass('displayed');
                                $('.no-product-notification').find('.notifContent').html(response.msg);
                                $('.other-products-header').addClass('displayed');
                                var scrollTopVal = $('.no-product-notification').offset().top - $('.navigation').height();
                                $('html, body').animate({
                                    scrollTop: scrollTopVal
                                }, 300);
                            }
                            return;
                        }
                        if (selectedColors) {
                            handleColorFilterLeadColor($(response));
                        }
                        parseResults(response);
                        initVisualCarousel.initCarousel();
                        handleCategories();
                        $.spinner().stop();
                        updateMetaDataTags(response);
                        $('.refinement-bar-sorting').remove();
                        if (firstLevelFilterEle.length > 0) {
                            handleQuickFilter(firstLevelFilterClass);
                        }

                        if (secondLevelFilterEle.length > 0) {
                            handleQuickFilter(secondLevelFilterClass);
                        }

                        handleEinstein();
                        handelExpandedFacets();
                        handleWishlistStatus();
                        initCategoryFilters();
                        if (!($('.retain-filter-wrapper').is(':visible'))) {
                            $('.mobFilterPills').addClass('d-none');
                        }
                        if (window.digitalData.page.category.pageType === 'cdp' && $('#retain-filter-attributes').length > 0 && $('.retain-filter-wrapper').is(':visible')) {
                            if ($(e.target).parents('.retain-filter-wrapper')) {
                                $(e.target).focus();
                            }
                            updateStoredFilterStatus();
                        }
                        if (isCustomFilterEnabled) {
                            handleCustomPriceFilter();
                        }

                        handleSizeFilter();

                        if (targetApplyFilterLink.parents('.refinement').length > 0) {
                            setTimeout(function () {
                                $('.applied-filters')[0].focus();
                            }, 800);
                        }

                        // Handling compare checkboxes on filter apply
                        if (sessionStorage.getItem('savedProducts') !== null && sessionStorage.getItem('savedProducts') !== '') {
                            var preSelectedProds = JSON.parse(sessionStorage.getItem('savedProducts'));
                            preSelectedProds.forEach(function (prod) {
                                var pid = prod.pid;
                                if ($('input[id=' + pid + ']').length) {
                                    $('input[id=' + pid + ']')[0].checked = true;
                                }
                            });

                            if (preSelectedProds.length >= 2) {
                                $('.skip-link').removeClass('d-none');
                            }

                            if (preSelectedProds.length === 3) {
                                $('.compare input:not(:checked)').attr('disabled', 'disabled');
                            }
                        }

                        if ($('div.seo-rich-content')) {
                            var topContent = $('p.seo-rich-content');
                            styleSEOContent(topContent);
                        }
                        if ($('div.seo-bottom-rich-content')) {
                            var bottomContent = $('div.seo-bottom-rich-content');
                            styleSEOContent(bottomContent);
                        }
                        // Adding interval for the recommender to load before initializing carousel on remove filter
                        var counter = 0;
                        var timer = setInterval(function () {
                            if ($('.recommendations-cdp .carousel-container .recommendations').length) {
                                var $swatches = $('.recommendations-cdp .swatches');
                                carouselInit.initProductCarousel();
                                productTile.initSwatch($swatches);
                                clearInterval(timer);
                            }
                            counter++;
                            if (counter === 15) {
                                clearInterval(timer);
                            }
                        }, 800);
                        setTimeout(function () {
                            // scroll to the product grid when filter applied
                            var filterPillHeight;
                            if (window.digitalData.page.category.pageType === 'cdp' && $('#retain-filter-attributes').length > 0 && storedfilteroptionsflag === 'true' && $('.retain-filter-wrapper').is(':visible')) {
                                filterPillHeight = $('.mobFilterPills').height();
                            } else {
                                filterPillHeight = mobile ? $('.mobFilterPills').height() : 0;
                            }
                            var stickyElementsHeight = $('.grid-header').outerHeight() + $('.navigation-container').height() + filterPillHeight;
                            $('html, body').animate({
                                scrollTop: $('.product-grid').offset().top - stickyElementsHeight
                            }, 700);
                            hideLoader();
                        }, 500);
                        if ($('.result-count').length) {
                            $('.result-count').focus();
                        }

                        if ($('.hybrid-sizing-enabled').length) {
                            handleHybridSizeTab();
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                        hideLoader();
                    }
                });
            }
        );
    };
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options')
        .options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * PLP Sorting
 */
function sort() {
    baseSearch.sort = function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            handleEinstein();
            showLoader();

            $.spinner().start();
            if (window.ffCdpStatePersist && 'URLSearchParams' in window && typeof history.pushState !== 'undefined') {
                var searchParams;
                var newRelativePathQuery;

                searchParams = new URLSearchParams(window.location.search);
                var srule = new URLSearchParams(this.value).get('srule');

                if (srule) {
                    searchParams.set('srule', srule);
                }
                newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();

                history.pushState(null, '', newRelativePathQuery);
            }
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    if (selectedSizes && window.ffCdpOOSProduct) {
                        updateOOSColorVariants($(response));
                    }
                    if (selectedColors) {
                        handleColorFilterLeadColor($(response));
                    }
                    updateRefinementsPostSorting(response);

                    if ($('.refinement-bar-sorting').length > 0) {
                        $('.refinement-bar-sorting').remove();
                    }

                    if (isCustomFilterEnabled) {
                        handleCustomPriceFilter();
                    }

                    if ($('.hybrid-sizing-enabled').length) {
                        handleHybridSizeTab();
                    }

                    if ($('.retain-filter-wrapper').is(':visible')) {
                        $('.no-filters').addClass('d-none');
                    }

                    handleSizeFilter();

                    $.spinner().stop();
                    hideLoader();
                },
                error: function () {
                    $.spinner().stop();
                    hideLoader();
                }
            });
        });
    };
}

/**
 * Show more product
 */
function showMore() {
    $('.container').off('click', '.show-more button');
    baseSearch.showMore = function () {
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $('.more-number-of-items').hide();
            $('.see-more-button').hide();
            $('.more-loading-spinner').show();

            var showMoreUrl = $(this).data('url');


            if (
                window.ffCdpStatePersist &&
                'URLSearchParams' in window &&
                typeof history.pushState !== 'undefined'
            ) {
                var searchParams;
                var newRelativePathQuery;
                var searchSize;

                searchParams = new URLSearchParams(window.location.search);
                searchSize =
                    parseInt(
                        new URLSearchParams(new URL(showMoreUrl).search).get(
                            'sz'
                        ),
                        10
                    ) +
                    parseInt(
                        new URLSearchParams(new URL(showMoreUrl).search).get(
                            'start'
                        ),
                        10
                    );

                searchParams.set('sz', searchSize);
                newRelativePathQuery =
                    window.location.pathname + '?' + searchParams.toString();

                history.pushState(null, '', newRelativePathQuery);
            }
            var pdPageWithQuickFilters = false;
            if (firstLevelFilterSelector.length > 0 || $('.secondLevelFilter').length > 0) {
                pdPageWithQuickFilters = true;
            }

            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: {
                    selectedUrl: showMoreUrl,
                    pdPageWithQuickFilters: pdPageWithQuickFilters
                },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    if (selectedSizes && window.ffCdpOOSProduct) {
                        updateOOSColorVariants($(response));
                    }
                    if (selectedColors) {
                        handleColorFilterLeadColor($(response));
                    }
                    $('.more-loading-spinner').hide();
                    $('.more-number-of-items').show();
                    $('.see-more-button').show();
                    addPaginationLinks(true);
                    handleWishlistStatus();
                }
            });
        });
    };
}

// Handling active filter pills when hybrid tab is selected
$(document).on('click', '.hybrid-size-tabs-ul .nav-item', function (e) {
    var selectedTab = $('.hybrid-size-tabs-ul .nav-link.active').attr('title');
    window.sessionStorage.setItem('currentHybridSizeTab', selectedTab);
    var selectedTabLabel = selectedTab === 'Intl' ? 'International' : selectedTab;
    var localizedSizingObj = $('#hybridSizingTabContent').data('sizing-json');
    var currentObj = localizedSizingObj[selectedTab];
    if ($('#active-filters-list').length || $('#active-filters-list-mobile').length) {
        var activeFilterLength = $('#active-filters-list .filtered-item').length ? $('#active-filters-list .filtered-item').length : $('#active-filters-list-mobile .filtered-item').length;

        // Handling for active filter pills under refinements
        for (let i = 0; i < activeFilterLength; i++) {
            if ($('#active-filters .filtered-item').eq(i).find('.size-value').attr('data-filterType') === 'size') {
                var size = $('.filtered-item').eq(i).find('.size-value .selected-filter').attr('data-size-value');
                var sizeValue = currentObj[size];
                if (selectedTab === 'US') {
                    $('#active-filters .filtered-item').eq(i).find('.size-value .selected-filter').text(size);
                } else {
                    $('#active-filters .filtered-item').eq(i).find('.size-value .selected-filter').text('US ' + size + ' (' + selectedTabLabel + ' ' + sizeValue + ')');
                }
            }
        }

        // Handling for selected filter pills above the product grid
        var selectedFilterCDP = $('.grid-header-inner #active-filters-list-mobile');
        if (selectedFilterCDP.length) {
            var selectedFilters = $('.grid-header .mobFilterPills .filtered-item');
            for (let j = 0; j < selectedFilters.length; j++) {
                if ($(selectedFilterCDP).find('.filtered-item').eq(j).find('.size-value')
                    .attr('data-filterType') === 'size') {
                    var selectedSize = $(selectedFilterCDP).find('.filtered-item').eq(j).find('.size-value .selected-filter')
                    .attr('data-size-value');
                    var selectedSizeValue = currentObj[selectedSize];
                    var filterType = $(selectedFilterCDP).find('.filtered-item').eq(j).find('.selected-filter')
                    .attr('data-filter-type');
                    if (selectedTab === 'US') {
                        $(selectedFilterCDP).find('.filtered-item').eq(j).find('.size-value .selected-filter')
                        .text(filterType + ': ' + selectedSize);
                    } else {
                        $(selectedFilterCDP).find('.filtered-item').eq(j).find('.size-value .selected-filter')
                        .text(`${filterType}: US ${selectedSize} (${selectedTabLabel} ${selectedSizeValue})`);
                    }
                }
            }
        }
    }

    // Handling for suggested filter pills above the product grid
    if ($('.grid-header .suggested-filters .filters').length || $('.grid-header .purchased-suggested-filters .filters').length) {
        var suggestedFilterCDP = [];
        if ($('.grid-header .suggested-filters .filters a').length) {
            suggestedFilterCDP.push($('.grid-header .suggested-filters .filters'));
        }

        if ($('.grid-header .purchased-suggested-filters .filters a').length) {
            suggestedFilterCDP.push($('.grid-header .purchased-suggested-filters .filters'));
        }
        if (suggestedFilterCDP.length) {
            $(suggestedFilterCDP).each(function () {
                var suggestedFilters = $(this).find('a[data-filter-id="size"]');
                if (suggestedFilters.length) {
                    for (let i = 0; i < suggestedFilters.length; i++) {
                        var suggSize = $(suggestedFilters).eq(i).attr('data-filter-value');
                        var suggSizeValue = currentObj[suggSize];
                        var suggFilterType = $(suggestedFilters).eq(i).attr('data-filter-type');
                        if (selectedTab === 'US') {
                            $(suggestedFilters).eq(i).text(suggFilterType + ': ' + suggSize);
                        } else {
                            $(suggestedFilters).eq(i).text(`${suggFilterType}: US ${suggSize} (${selectedTabLabel} ${suggSizeValue})`);
                        }
                    }
                }
            });
        }
    }

    if (e.originalEvent && e.originalEvent.isTrusted) {
        _satellite.track('local-size-interaction', {
            component: {
                id: 'local-size-interaction',
                details: selectedTab.toLowerCase()
            }
        });
    }
});

/**
 * Show more content in content search
 */
function showMoreContent() {
    $('.container').on('click', '.show-more-content button', function (e) {
        e.stopImmediatePropagation();
        var $element = $(this);
        var $target = $('#content-search-results .result-count');
        var showMoreUrl = $element.data('url');

        if (
            window.ffCdpStatePersist &&
            'URLSearchParams' in window &&
            typeof history.pushState !== 'undefined'
        ) {
            var searchParams;
            var newRelativePathQuery;
            var searchSize;

            searchParams = new URLSearchParams(window.location.search);
            searchSize = parseInt(
                new URLSearchParams(new URL(showMoreUrl).search).get(
                    'startingPage'
                ),
                10
            );

            searchParams.set('startingPage', searchSize);
            newRelativePathQuery =
                window.location.pathname + '?' + searchParams.toString();

            history.pushState(null, '', newRelativePathQuery);
        }

        $.ajax({
            url: showMoreUrl,
            method: 'GET',
            success: function (response) {
                $target.append(response);
                $('.show-more-content').remove();
                $('.result-count .col-12 .card').unwrap();
            }
        });
    });
}

$(document).on('click', '.search-nav .nav-link', function (e) {
    var searchParams;
    var newRelativePathQuery;

    searchParams = new URLSearchParams(window.location.search);
    searchParams.set(
        'view',
        e.currentTarget.className.indexOf('content-search') > -1 ?
        'content' :
        'product'
    );
    newRelativePathQuery =
        window.location.pathname + '?' + searchParams.toString();

    history.pushState(null, '', newRelativePathQuery);
});

/**
 * update product tile image on click and update variation price if required
 */
$(document).on('click keypress', '.swatchAnchor', function () {
    let $this = $(this).find('img.cdp-swatches');
    var imageContainer = $this.closest('.product-tile').find('.image-container');
    var quickAddAnchor = $this.closest('.product-tile').find('.quickview');
    var imageAnchorTag = imageContainer.find('a');
    var nameAnchor = $this.closest('.product-tile').find('.pdp-link .link');
    var ratingAnchor = $this.closest('.product-tile').find('.cdp-ratings a');
    var imgDefault = imageContainer.find('.default-image');
    var imgHover = imageContainer.find('.hover-image');
    var selectedSwatch = $this.closest('a');
    var selectedSwatchGroup = $this.closest('.swatches');
    $this.closest('.swatches').find('.selected').removeClass('selected');
    selectedSwatch.addClass('selected');

    selectedSwatchGroup.find('.swatchAnchor').each(function () {
        var swatchColor = $(this).attr('data-color-val');
        if ($(this).hasClass('selected')) {
            $(this).attr('aria-label', swatchColor + ' selected');
        } else {
            $(this).attr('aria-label', swatchColor + ' not selected');
        }
    });

    var promoDiv = document.createElement('div');
    $(promoDiv).addClass('promoCallout');
    var hoverUrl = $this.data('hover-url');
    var promoBadge = $this.data('hover-promotag');
    var isLowInStock = $this.data('islis');
    var lowInStockBadge = $this.data('lis-msg');
    $.ajax({
        url: hoverUrl,
        method: 'GET',
        success: function (data) {
            var response = $(data).find('.image-container');
            var responseAnchor = response.find('a');
            var responseHrefLink = responseAnchor.attr('href');
            var dataLuluAttribute = responseAnchor.attr('data-lulu-attributes');

            var responseImgDefaultSrc = response.find('.default-image').attr('data-src');
            var responseImgDefaultSrcSet = response.find('.default-image')
                .parent('picture')
                .find('source')
                .attr('data-srcset');

            var responseHoverImg = response.find('.hover-image');
            var responseImgHoverSrc = responseHoverImg.attr('data-src');
            var responseImgHoverSrcSet = responseHoverImg
                .parent('picture')
                .find('source')
                .attr('data-srcset');
            $this.closest('.product-tile').find('.image-container').find('a')
                .eq(1)
                .attr('href', responseHrefLink);

            var newQuickAddURL = $(data).find('.quickview').attr('href');
            quickAddAnchor.attr('href', newQuickAddURL);
            nameAnchor.attr('href', responseHrefLink);
            ratingAnchor.attr('href', responseHrefLink + '#BazaarVoice');
            imageAnchorTag.attr('href', responseHrefLink);
            imageAnchorTag.eq(0).attr('data-lulu-attributes', dataLuluAttribute);
            imgDefault.attr('data-src', responseImgDefaultSrc);
            imgDefault.attr('src', responseImgDefaultSrc);
            imgDefault.siblings('source').eq(0).attr('data-srcset', responseImgDefaultSrcSet);
            imgDefault.siblings('source').eq(1).attr('data-srcset', responseImgDefaultSrcSet.replace('800,800', '400,400'));
            imgDefault.siblings('source').eq(2).attr('data-srcset', responseImgDefaultSrcSet.replace('800,800 2x', '300,300'));
            imgDefault.siblings('source').eq(0).attr('srcset', responseImgDefaultSrcSet);
            imgDefault.siblings('source').eq(1).attr('srcset', responseImgDefaultSrcSet.replace('800,800', '400,400'));
            imgDefault.siblings('source').eq(2).attr('srcset', responseImgDefaultSrcSet.replace('800,800 2x', '300,300'));
            if (imageContainer.find('.promoCallout').length > 0) {
                imageContainer.find('.promoCallout').remove();
            }
            if (promoBadge) {
                promoDiv.innerText = promoBadge;
                imageContainer.append(promoDiv);
            } else if (promoDiv.length > 0) {
                promoDiv.css('display', 'none');
                $('.promoCallout').css('display', 'none');
            }
            if (isLowInStock) {
                imageContainer.find('.promoCallout').addClass('d-none');
                if (!imageContainer.find('.lis-badge').length) {
                    imageContainer.append('<div class="lis-badge">' + lowInStockBadge + '</div>');
                } else {
                    imageContainer.find('.lis-badge').removeClass('d-none');
                }
            } else {
                imageContainer.find('.lis-badge').addClass('d-none');
            }
            if (imgHover.length > 0 && responseHoverImg.length > 0) {
                // when both are present, simply replace
                imgHover.attr('src', responseImgHoverSrc);
                imgHover.attr('data-src', responseImgHoverSrc);
                imgHover.siblings('source').eq(0).attr('data-srcset', responseImgHoverSrcSet);
                imgHover.siblings('source').eq(1).attr('data-srcset', responseImgHoverSrcSet.replace('800,800', '400,400'));
                imgHover.siblings('source').eq(2).attr('data-srcset', responseImgHoverSrcSet.replace('800,800 2x', '300,300'));
                imgHover.siblings('source').eq(0).attr('srcset', responseImgHoverSrcSet);
                imgHover.siblings('source').eq(1).attr('srcset', responseImgHoverSrcSet.replace('800,800', '400,400'));
                imgHover.siblings('source').eq(2).attr('srcset', responseImgHoverSrcSet.replace('800,800 2x', '300,300'));
            } else if (!imgHover.length && responseHoverImg.length > 0) {
                // append hover-image from response
                imageAnchorTag.find('picture').append(responseHoverImg);
            }
        }
    });

    if ($this.closest('.tile-body').find('.dynamicPricing').length) {
        var swatchSalePrice = $this.closest('a').data('swatch-sale-price').trim();
        var swatchRegPrice = $this.closest('a').data('swatch-list-price').trim();
        var rangePriceField = $this.closest('.tile-body').find('.price-link .range');
        var strikeOutPriceField = $this.closest('.tile-body').find('.dynamicPricing .strikedOutPrice')[0];
        var salePriceField = $this.closest('.tile-body').find('.dynamicPricing .salePrice')[0];

        if (swatchRegPrice !== swatchSalePrice) {
            rangePriceField.hide();
            salePriceField.innerHTML = '<div class="sales"><span class="value" content="' + swatchSalePrice + '"><ins class="text-decoration-none">' + swatchSalePrice + '</ins></span></div>';
            strikeOutPriceField.innerHTML = '<del>' + swatchRegPrice + '</del>';
            $this.closest('.tile-body').find('.price-vary-msg').hide();
        } else {
            rangePriceField.hide();
            salePriceField.innerHTML = '<div class="sales"><span class="value" content="' + swatchRegPrice + '"><ins class="text-decoration-none">' + swatchRegPrice + '</ins></span></div>';
            strikeOutPriceField.innerHTML = '';
            $this.closest('.tile-body').find('.price-vary-msg').hide();
        }
    }
});

$(document).on('mouseenter focusin', '.product-tile .image-container', function () {
    var imgHover = $(this).find('.hover-image');
    imgHover.addClass('hovered lazyload').css('display', 'block');
});

$(document).on('wishlist:updateWishlistState', function () {
    handleWishlistStatus();
});

/**
 * Document ready function
 * @param {funtion} fn - return function
 */
function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

ready(function () {
    if ($('.wishlistitems').text().length > 0) {
        localStorage.setItem('wishlistItems', '');
        localStorage.setItem('wishlistItems', JSON.stringify($('.wishlistitems').text().split(',')));
        var wishlistItems = JSON.parse(localStorage.getItem('wishlistItems'));
        for (var i = 0; i < wishlistItems.length; i++) {
            var $tileElement = $('#' + wishlistItems[i]);
            $tileElement.find('.wishlistTile').addClass('remove-from-wishlist');
            $tileElement.find('.wishlistTile').attr('title', $tileElement.find('.wishlistTile').data('remove-wishlist'));
            $tileElement.find('.icon-wishlist').removeClass('icon-wishlist-o');
            if ($tileElement.hasClass('wishlist-icon-pdp')) {
                $tileElement.find('.wishlistTile').attr('href', $tileElement.find('.wishlistTile').data('remove-url'));
            }
            $tileElement.find('.icon-wishlist').addClass('icon-wishlist-s');
        }
    } else {
        localStorage.setItem('wishlistItems', JSON.stringify([]));
    }

    addPaginationLinks(false);
    // Handling the first level filter
    if (firstLevelFilterEle.length > 0) {
        handleQuickFilter(firstLevelFilterClass);
        $('.firstLevelFilter li:first-child a').click(function () {
            document.querySelector('meta[name="robots"]').setAttribute('content', 'index, follow, noodp, noydir');
        });
    }
    // Handling the second level filter
    if (secondLevelFilterEle.length > 0) {
        handleQuickFilter(secondLevelFilterClass);
        $('.secondLevelFilter .swiper-wrapper .experience-dynamic-filterTile:first-child a').click(function () {
            document.querySelector('meta[name="robots"]').setAttribute('content', 'index, follow, noodp, noydir');
        });
    }
});

$(window).on('load', function () {
    addAriaAttirbutes();
    handleHybridSizeTab();
    if (isCustomFilterEnabled) {
        handleCustomPriceFilter();
    }
});

module.exports = {
    openSeeAll: openSeeAll,
    applyFilter: applyFilter,
    filter: filter,
    closeRefinments: closeRefinments,
    viewItems: viewItems,
    resize: resize,
    showMoreContent: showMoreContent,
    showMore: showMore,
    sort: sort
};
